import { Box, Dialog, Grid, Collapse, Popover, useTheme, useMediaQuery, Link, Menu, MenuItem, IconButton, ListItemIcon, Typography } from "@mui/material";
import Header from "../../common/Header";
import CustomTextField from "../../common/CustomTextField";
import CustomInvoiceAging from "../../common/CustomInvoiceAging";
import {
  AssignmentReturnedOutlined,
  AttachMoney,
  BoltOutlined,
  CloudDownload,
  CreditCard,
  DownloadOutlined,
  EditNote,
  EditOutlined,
  ExitToApp,
  Share,
  KeyboardArrowDown,
  ListAltOutlined,
  ModeOutlined,
  Notifications,
  NotificationsOutlined,
  Payment,
  SearchOutlined,
  TableViewOutlined,
  CloseOutlined,
  TrackChanges,
  CurrencyExchangeOutlined,
  HistoryOutlined,
  PaymentsOutlined,
} from "@mui/icons-material";
import Card from "../../common/Card";
import { useForm } from "react-hook-form";
import Button from "../../common/Button";
import Table from "../../common/CustomTable";
import { useLocation } from "react-router-dom";
import {
  SearchInvoiceInfo,
  fetchInvoiceList,
  invoiceInfo,
  stripeCheckOutPaymentData,
  useInvoiceSlice,
  changeInvoiceStatus,
  resetInvoiceList,
  addLateFeeByInvoice,
} from "../../../redux/slice/invoice/InvoiceSlice";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  AgencyInfo,
  fetchAgenciesList,
  fetchManufacturersList,
  setSingleAlertObj,
  showHideLoadingDialog,
  SingleAlertInfo,
  useCommonReducer,
} from "../../../redux/slice/commonSlice";
import CustomMultipleDropDown from "../../common/CustomMultipleDropDown";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import {
  fetchDocumentById,
  getPracticeListforFilter,
  usePracticeSlice,
} from "../../../redux/slice/practiceSlice";
import {
  selectIsValueFoundInToken,
  selectTokenValues,
  useAuthSlice,
} from "../../../redux/slice/authSlice";
import { CAN_ACCESS_APPLICATION, COMMISSION_STATUS, EXPORTABLE_ITEMS, INVOICE_ACTION, INVOICE_STATUS, USER_ROLE_ENTITY_NAMES, AUDIT_ENTITYS, USER_ROLES } from "../../../constants/applicationConstants";
import { UserRole, fetchAllUserRoles, fetchUserPreference, saveUserPreference } from "../../../redux/slice/userSlice";
import ColumnToggle from "../../common/ColumnToggle";
import dayjs from "dayjs";
import CustomCheckbox from "../../common/CustomCheckBox";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import UploadPaymentsPopup from "./UploadPaymentsPopup";
import { fullName, hideElement, priceFormatter, rederDynamicStatusColor, renderDynamicAgingColumn, sortNames } from "../../../utils/Utility";
import { canShowUpdateInvoice } from "../../../utils/invoiceUpdateVisibility";
import { createListSort } from "../../../utils/listSort";
import { asEntityNumber, buildActivityCenterPath } from "../../../utils/activityCenterUtils";
import CustomIconButton from "../../common/CustomIconButton";
import CustomDateRange from "../../common/CustomDateRange";
import { getSearchCriteriaFromSessionStorage, saveSelectionForPage, setSearchCriteriaToSessionStorage } from "../../../utils/StorageUtils";
import { DateObject } from "react-multi-date-picker";
import { tokens } from "../../../theme";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ExportToExcel from "../../common/ExportToExcel";
import CustomMonthYearPicker from "../../common/CustomMonthYearPicker";
import { format, isValid, parse } from "date-fns";
import { useNavigation } from "../../../hooks/useNavigation";
import { useFilterPanelFocus } from "../../../hooks/useFilterPanelFocus";
import StyledMenu from "../../common/StyledMenu";
import {  getPatientListForFilter, usePatientReducer } from "../../../redux/slice/patient/patientSlice";
import CustomDropdownField from "../../common/CustomDropdownFiled";
import { useBranding } from "../../../BrandingContext";
// CS-1765 - Import product list slice for product-based bulk payment dropdown
import { fetchProductsForProductsSearch, useProductListReducer, ProductInfo } from "../../../redux/slice/product/productListSlice";
import { acknowledgeNotification, fetchAlertEntityNumbers, fetchNotificationsByRefEntities, useCreateNotificationSlice } from "../../../redux/slice/inbox/createNotificationSlice";
import StatusInfoPopup from "../../common/StatusInfoPopup";
import StripePaymentTypePopup from "../payment/stripe/StripePaymentTypePopup";
import OptionsPopup, { OptionPopupObjectProps } from "../../common/OptionsPopup";
import LateFeePopup from "./LateFeePopup";
import PDFViewer from "../../common/pdf/PDFViewer";
import BulkInvoicePayment from "./BulkInvoicePayment";
import ShareInvoicePopup from "./ShareInvoicePopup"; // CS-1666
import { useListPageStyles } from "../../common/useListPageStyles";
import { useModalStyles } from "../../common/useModalStyles";
import { OverridePayoutInvoice, RecordPayoutOverrideForm } from "./RecordPayoutOverride";
import { AgencyPayoutInvoice, RecordPayoutForm } from "./RecordPayout";
import EditCommissionPopup from "../orders/EditCommissionPopup";
import {
  invoiceHasServiceFeePayment,
  resolveServiceFeeAmountEdit,
  saveServiceFeeAmountEdit,
  ServiceFeeAmountEditTarget,
  ServiceFeeKind,
} from "../../../utils/serviceFeeAmountEdit";
import { CodeTable, fetchAllCodeTablesValues, getCodeTableValuesByTableName, useCodetablesSlice } from "../../../redux/slice/codetableSlice";

interface Column {
  id: string;
  label: string | JSX.Element;
  minWidth?: number;
  align?: "right" | "center" | "left";
  format?: (value: number) => string;
  padding?: string;
}

interface invoiceTableRow extends invoiceInfo {
  // checkBox: JSX.Element | any;
  rawMfgInvoiceNumberLink?: string | number | null; // CS-1517 - For custom sorting
  rawInvoiceLateDays?: string | number | null; // CS-1588 - For custom sorting
  actualRemainingAmount?: number |null
}

const invoiceListSort = createListSort(
  ["mfgInvoiceNumber", "mfgInvoiceDate", "invoiceDueDate", "invoiceLateDays", "manufacturerName", "practiceName", "invoiceAmount", "remainingAmount", "invoiceStatus"] as const,
  {
    mfgInvoiceNumberLink: "mfgInvoiceNumber",
    mfgInvoiceDate: "mfgInvoiceDate",
    invoiceDueDate: "invoiceDueDate",
    invoiceLateDays: "invoiceLateDays",
    manufacturerName: "manufacturerName",
    practiceName: "practiceName",
    invoiceAmount: "invoiceAmount",
    remainingAmount: "remainingAmount",
    customInvoiceStatus: "invoiceStatus",
  }
);

const InvoiceList = () => {
  const { control, handleSubmit, setValue, getValues, watch, trigger, clearErrors } =
    useForm<SearchInvoiceInfo>();
  const { navigate } = useNavigation();
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const {
    cardSx,
    filterPanelSx,
    primaryActionBtnSx,
    outlineBtnSx,
    exportMenuPaperSx,
    exportMenuItemBtnSx,
    tableSx,
  } = useListPageStyles();
  
  const { tokens: modalTokens, paperSx, headerSx, iconBoxSx, bodySx, closeIconSx } = useModalStyles();
  const invoiceFilterBtnSx = {
    ...outlineBtnSx,
    color: "#38bdf8",
    borderColor: "rgba(56,189,248,0.65)",
    backgroundColor: "transparent",
    "& .MuiButton-startIcon, & svg": { color: "#38bdf8" },
    "&:hover": {
      color: "#7dd3fc",
      borderColor: "#38bdf8",
      backgroundColor: "rgba(56,189,248,0.1)",
      boxShadow: "0 6px 20px rgba(56,189,248,0.18)",
    },
  };
  const invoiceBulkPaymentBtnSx = {
    ...primaryActionBtnSx,
    color: "#fff",
    backgroundColor: "#f9a825",
    borderColor: "#f9a825",
    boxShadow: "0 4px 18px rgba(249,168,37,0.35)",
    "& .MuiTypography-root, & .MuiButton-startIcon, & svg": { color: "#fff" },
    "&:hover": {
      color: "#fff",
      backgroundColor: "#f59e0b",
      borderColor: "#f59e0b",
      boxShadow: "0 8px 24px rgba(245,158,11,0.3)",
    },
    "&:focus, &:focus-visible": {
      boxShadow: "0 0 0 3px rgba(249,168,37,0.24)",
    },
  };
  const invoiceShareBtnSx = {
    ...primaryActionBtnSx,
    color: "#fff",
    backgroundColor: "#ef5350",
    borderColor: "#ef5350",
    boxShadow: "0 4px 18px rgba(239,83,80,0.3)",
    "& .MuiTypography-root, & .MuiButton-startIcon, & svg": { color: "#fff" },
    "&:hover": {
      color: "#fff",
      backgroundColor: "#dc2626",
      borderColor: "#dc2626",
      boxShadow: "0 8px 24px rgba(239,83,80,0.28)",
    },
    "&:focus, &:focus-visible": {
      boxShadow: "0 0 0 3px rgba(239,83,80,0.24)",
    },
  };
  const invoiceColumnToggleBtnSx = {
    color: "#14b8a6",
    borderColor: "rgba(20,184,166,0.55)",
    backgroundColor: theme.palette.mode === "dark" ? "rgba(20,184,166,0.08)" : "rgba(20,184,166,0.04)",
    width: 40,
    height: 40,
    "& svg": { color: "#14b8a6" },
    "&:hover": {
      color: "#fff",
      borderColor: "#14b8a6",
      backgroundColor: "#14b8a6",
      "& svg": { color: "#fff" },
    },
  };
  const invoiceExportBtnSx = {
    textTransform: "none",
    fontWeight: 700,
    fontSize: "0.86rem",
    borderRadius: "10px",
    py: 1.05,
    px: 1.6,
    color: "#14B8A6",
    borderColor: "rgba(20,184,166,0.55)",
    backgroundColor: theme.palette.mode === "dark" ? "rgba(20,184,166,0.08)" : "rgba(20,184,166,0.04)",
    whiteSpace: "nowrap",
    "& .MuiSvgIcon-root": {
      color: "#14B8A6",
    },
    "&:hover": {
      color: "#fff",
      borderColor: "#14B8A6",
      backgroundColor: "#14B8A6",
      boxShadow: "0 6px 22px rgba(20,184,166,0.28)",
      "& .MuiSvgIcon-root": {
        color: "#fff",
      },
    },
  };
  const branding = useBranding();
  const { NotificationInfoByRefEntity} = useCreateNotificationSlice();
  const legacyItems = [{ icon: <ModeOutlined color="info" />, text: "Edit" }];
  const { manufacturerInfoList, agencyInfoList } = useCommonReducer();
  const { practiceByUserRole } = usePracticeSlice();
  const { userInfo } = useAuthSlice();
  const { patientsByUserRole } = usePatientReducer();
  const { invoiceList } = useInvoiceSlice();
  // CS-1765 - Get products by user role for product-based bulk payment dropdown
  const { productsByUserRole } = useProductListReducer();
  const { allCodeTablesValuesMap } = useCodetablesSlice();
  const [showCard, setShowCard] = useState(false);
  const {
    filterPanelRef,
    toggleFilterPanel,
    handleFilterPanelEntering,
    handleFilterPanelEntered,
    handleFilterPanelExited,
  } = useFilterPanelFocus(showCard, setShowCard);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [hiddenColumns, setHiddenColumns] = useState<string[]>([]);
  const [showUploadPaymentsPopup, setShowUploadsPaymentsPopup] =
    useState(false);
  const [selectedMfgAndPractice, setSelectedMfgAndPractice] = useState<{
    manufacturerId: number | null;
    practiceId: number | null;
  }>({ manufacturerId: null, practiceId: null });
  const [anchorElMenu, setAnchorElMenu] = useState<null | HTMLElement>(null);
  const [totalNotificationIds, setTotalNotificationIds] = useState([]);
  const [alertedInvoiceIds, setAlertedInvoiceIds] = useState<number[]>([]);
  const [notificationData, setNotificationData] = useState<any[]>([]);
    const [statusAnchorEl, setStatusAnchorEl] = useState<HTMLElement | null>(null);
  const [isAlertOnly, setIsAlertOnly] = useState<boolean>(false);
  const [isDateRangeChanged, setIsDateRangeChanged] = useState(false);
  const [isClearDateRange, setIsClearDateRange] = useState(false);
  const ITEMS_PER_PAGE = 10;

  const [showOptionPopup, setShowOptionsPopup] = useState<OptionPopupObjectProps>({ message: "", show: false }); // CS-1532

  const canAccessRecordCreditMemoAction = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessInvoiceActions", INVOICE_ACTION.CREDIT_MEMO)(state));
  const canAccessAddPaymentAction = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessInvoiceActions", INVOICE_ACTION.ADD_PAYMENT)(state));
  const canCreateStripePayment = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessInvoiceActions", INVOICE_ACTION.STRIPE_PAYMENT)(state));
  const canAccessEditInvoiceAction = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessInvoiceActions", INVOICE_ACTION.EDIT_INVOICE)(state));
  const canAccessCloseInvoiceAction = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessInvoiceActions", INVOICE_ACTION.CLOSE_INVOICE)(state)); // CS-1532
  const canAuditInvoice = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessAuditAction", AUDIT_ENTITYS.INVOICEAUDIT)(state)); // CS-1532
  const canLateFeeAction = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessInvoiceActions", INVOICE_ACTION.LATE_FEE)(state));
  const canAccessBulkPayment = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessInvoiceActions", INVOICE_ACTION.STRIPE_PAYMENT)(state));
  const canShareInvoice = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessInvoiceActions", INVOICE_ACTION.SHARE_INVOICE)(state)); // CS-1666
  const canAccessActivityCenter = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessInvoiceActions", INVOICE_ACTION.ACTIVITY_CENTER)(state));
  const canAccessCreateOVRAGYPayout = useSelector((state: RootState) => selectIsValueFoundInToken("canCreatePayOut", INVOICE_STATUS.OVERRIDE)(state));
  const canAccessCreateAGYPayout = useSelector((state: RootState) => selectIsValueFoundInToken("canCreatePayOut", INVOICE_STATUS.AGENCY)(state));
  const canEditCommissionRate = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessCommissionActions", COMMISSION_STATUS.EDIT)(state));
  const canAccessPurchaseAndBillFilter =
    userInfo?.userRole === USER_ROLES.ROLE_SUPERADMIN ||
    userInfo?.userRole === USER_ROLES.ROLE_ADMIN;
  const [userPreferencesLoaded, setUserPreferencesLoaded] = useState(false);
  const [activeButtonId, setActiveButtonId] = useState<string | null>(null);
  const canAccessNotifications = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessApplication", CAN_ACCESS_APPLICATION.NOTIFICATION_MANAGEMENT)(state));
  const accessibleNotifications = useSelector((state: RootState) => selectTokenValues("canAccessNotifications")(state));
  //CS-1458 - Opening Stripe payment type popup on pay now
  const [selectedInvoiceData, setSelectedInvoiceData] = useState<any>(null);
  const [showStripePaymentTypePopup, setShowStripePaymentTypePopup] = useState(false);
  
  // Bulk Payment Popup
  const [showBulkPaymentPopup, setShowBulkPaymentPopup] = useState(false);

  // CS-1666 - Share Invoice Popup
  const [showShareInvoicePopup, setShowShareInvoicePopup] = useState(false);

  // Restore activeButtonId from sessionStorage on mount
  useEffect(() => {
    dispatch(showHideLoadingDialog(true))
    const saved = sessionStorage.getItem("activeActionButtonId");
    if (saved) {
      setActiveButtonId(saved);
    }
  }, []);

  const [ loadingComplete, setLoadingComplete ] = useState<Boolean>(false);
  const [fetchInitDataCompleted, setFetchInitDataCompleted] = useState<Boolean>(false);
  const [fetchNotificationCountCompleted, setFetchNotificationCountCompleted] = useState<Boolean>(false);
  const [fetchNotificationsCompleted, setFetchNotificationsCompleted] = useState<Boolean>(false);
  const canExportInvoiceList = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessExportExcel", EXPORTABLE_ITEMS.INVOICE)(state));

  const [overridePayoutInvoices, setOverridePayoutInvoices] = useState<OverridePayoutInvoice[] | null>(null);
  const [agencyPayoutInvoices, setAgencyPayoutInvoices] = useState<AgencyPayoutInvoice[] | null>(null);
  const [serviceFeeEdit, setServiceFeeEdit] = useState<ServiceFeeAmountEditTarget | null>(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState<number | null>(null);
  const [lateFeeAmount, setLateFeeAmount] = useState<number>(0);

  const [pdfContent, setPDFContent] = useState<string>("");
  const [showPDF, setShowPDF] = useState<{
    isShow: boolean;
    noteName: string;
    fileName: string;
  }>({ isShow: false, noteName: "", fileName: "" });

  // Watch checkbox values for bulk payment
  const checkBoxValues = watch('checkBox') || {};
  const selectAllCheckBoxValue = watch('selectAllCheckBox') || false;

  // Watch selected manufacturers to filter the product dropdown by manufacturer
  const selectedMfgIds = watch('mfgIds') || [];

  // Watch selected practices to filter the patient dropdown by practice
  const selectedPracticeIds = (watch('practiceIds') || []) as number[];

  // CS-2028 - Watch the aging preset so the Custom Min/Max fields only render when "Custom" is chosen
  const selectedAging = watch('invoiceAging');
  const agingMin = watch('invoiceAgeMin');
  const agingMax = watch('invoiceAgeMax');
  const previousAgingRef = useRef<string[]>([]);

  // CS-2028 - While "Custom" is active, keep Min/Max validated as a pair: both show the required
  useEffect(() => {
    if (Array.isArray(selectedAging) && selectedAging.includes("CUSTOM")) {
      trigger(["invoiceAgeMin", "invoiceAgeMax"]);
    } else {
      clearErrors(["invoiceAgeMin", "invoiceAgeMax"]);
    }
  }, [selectedAging, agingMin, agingMax, trigger, clearErrors]);

  // Calculate selected invoice count - use JSON.stringify for stable dependency
  const selectedInvoiceCount = useMemo(() => {
    const values = checkBoxValues;
    
    if (!values || typeof values !== 'object') {
      console.log('Invalid checkBoxValues:', values);
      return 0;
    }
    
    // Filter for true values only
    const trueKeys = Object.keys(values).filter(
      key => values[key] === true
    );
    
    const checkedCount = trueKeys.length;
    
    // Debug logging
    console.log('Checkbox values:', values);
    console.log('True keys:', trueKeys);
    console.log('Selected count:', checkedCount);
    
    return checkedCount;
  }, [JSON.stringify(checkBoxValues)]);

// CS-1300 - START
  // Only fetch user preferences once on mount
  useEffect(() => {
  let isMounted = true;

  const fetchInitialData = async () => {
    try {
      const [
        manufacturersResult,
        agenciesResult,
        preferencesResult,
        practicesResult,
        patientsResult,
        // CS-1765 - Fetch products by user role for bulk payment product dropdown
        productsResult
      ] = await Promise.all([
        dispatch(fetchManufacturersList()),
        dispatch(fetchAgenciesList()),
        dispatch(fetchUserPreference(userInfo.userId)),
        dispatch(getPracticeListforFilter()),
        dispatch(getPatientListForFilter()),
        // Fetch products by user role INCLUDING inactive (role-scoped) so the product filter can show inactive products too
        dispatch(fetchProductsForProductsSearch(false)),
        dispatch(fetchAllCodeTablesValues())
      ]);

      if(isMounted && manufacturersResult && agenciesResult && 
        preferencesResult && practicesResult && patientsResult
        && productsResult
      ){
        setFetchInitDataCompleted(true)
      }

      if (!isMounted) return;

      const preferences = preferencesResult.payload || [];
      const preferredColumns = preferences.find(
        (pref: { preferenceName: string }) =>
          pref.preferenceName === "preferredInvoiceListColumns"
      );

      if (preferredColumns) {
        setHiddenColumns(preferredColumns.preferenceValue.split(";"));
      } else if (userInfo.userRole === "ROLE_ADMIN") {
        setHiddenColumns([
          "agencyName",
          "agencyCommissionAmount",
          "agencyCommissionPaidAmount",
          "overrideAgencyName",
          "ovrAgencyCommissionAmount",
          "ovrAgencyCommissionPaidAmount",
        ]);
      }

      setUserPreferencesLoaded(true);
    } catch (err) {
      console.error("Error loading initial data", err);
    }
  };

  fetchInitialData();
  return () => {
    isMounted = false;
  };
}, [dispatch, userInfo.userId, userInfo.userRole]);


const prevHiddenColumnsRef = useRef<string[]>([]);

useEffect(() => {
  if (userPreferencesLoaded) {
    const prev = prevHiddenColumnsRef.current;
    const current = hiddenColumns;

    const hasChanged =
      prev.length !== current.length ||
      prev.some((val, i) => val !== current[i]);

    if (hasChanged) {
      const hiddenColumnsString = current.join(";");
      dispatch(
        saveUserPreference({
          userId: userInfo?.userId,
          preferenceName: "preferredInvoiceListColumns",
          preferenceValue: hiddenColumnsString,
        })
      );
      prevHiddenColumnsRef.current = [...current];
    }
  }
}, [hiddenColumns, userPreferencesLoaded, dispatch, userInfo?.userId]);


// Only run searchInvoiceList once after user preferences are loaded
useEffect(() => {
  if (!userPreferencesLoaded) return;

  const {
    orderNumber,
    mfgInvoiceNumber,
    fromDate,
    toDate,
    invoiceListSearchCriteria,
    withSearchHistory
  } = location.state || {};

  const criteriaKey = `${CAN_ACCESS_APPLICATION.INVOICE_MANAGEMENT}SearchCriteria${userInfo.userId}`;
  const savedCriteria = getSearchCriteriaFromSessionStorage(criteriaKey);

  if (orderNumber || mfgInvoiceNumber) {
    setShowCard(true);
    if (orderNumber) setValue("orderNumber", orderNumber);
    if (mfgInvoiceNumber) setValue("mfgInvoiceNumber", mfgInvoiceNumber);

    searchInvoiceList(1, {
      ...getValues(),
      orderNumber: orderNumber || "",
      mfgInvoiceNumber: mfgInvoiceNumber || "",
      fromDate: fromDate || "",
      toDate: toDate || "",
    });

    if (!fromDate && !toDate) setIsClearDateRange(true);
    return;
  }

  if (invoiceListSearchCriteria || (withSearchHistory && savedCriteria)) {
    const criteria = invoiceListSearchCriteria || savedCriteria;
    if (withSearchHistory) {
      navigate("/invoice_list", { state: { invoiceListSearchCriteria: criteria }, replace: true }); // force reload
      return;
    }

    setValuesToCriteriaFields(criteria);
    searchInvoiceList(criteria.currentPage || 1, criteria);
    return;
  }

  const localFrom = getValues("fromDate");
  const localTo = getValues("toDate");

  if (localFrom && localTo) {
    searchInvoiceList(1, { ...getValues(), fromDate: localFrom, toDate: localTo });
    setIsDateRangeChanged(false);
  } else {
    searchInvoiceList(1, getValues());
  }
}, [location.state, practiceByUserRole, manufacturerInfoList, userPreferencesLoaded]);

// CS-1300 - END

  const setValuesToCriteriaFields = (searchCriteria: SearchInvoiceInfo) => {
    setValue("mfgInvoiceNumber", searchCriteria.mfgInvoiceNumber);
    setValue("orderNumber", searchCriteria.orderNumber);
    setValue("mfgIds", searchCriteria.mfgIds);
    setValue("practiceIds", searchCriteria.practiceIds);
    setValue("invoiceStatus", searchCriteria.invoiceStatus);
    setValue("invoiceAgeMin", searchCriteria.invoiceAgeMin);
    setValue("invoiceAgeMax", searchCriteria.invoiceAgeMax);
    // Restore both current arrays and legacy single-value stored searches.
    const storedAging = searchCriteria.invoiceAging;
    const restoredAging = Array.isArray(storedAging)
      ? storedAging
      : storedAging
        ? [storedAging]
        : deriveAgingBucket(searchCriteria.invoiceAgeMin, searchCriteria.invoiceAgeMax);
    previousAgingRef.current = restoredAging;
    setValue("invoiceAging", restoredAging);
    setValue("currentPage", searchCriteria.currentPage);
    const restoredSort = invoiceListSort.pick(searchCriteria);
    setValue("sortBy", restoredSort.sortBy);
    setValue("sortOrder", restoredSort.sortOrder);
    setValue("itemsPerPage", searchCriteria.itemsPerPage);
    setValue("serialNumber", searchCriteria.serialNumber);
    setValue("usageStatus", searchCriteria.usageStatus);
    setValue("productIds", searchCriteria.productIds);
    setValue("purchaseAndBillFilter", searchCriteria.purchaseAndBillFilter);
    setValue("patientIds", searchCriteria.patientIds);
    setValue("agencyIds", searchCriteria.agencyIds);
    setValue("commPeriod", searchCriteria.commPeriod);
    if (searchCriteria.comm) {
      setValue("comm", searchCriteria.comm);
    } else if (searchCriteria.commPeriod) {
      const parsedDate = parse(
        searchCriteria.commPeriod.split(" - ")[0].trim(),
        "MMM yy",
        new Date()
      );
      if (isValid(parsedDate)) {
        setValue("comm", parsedDate.toISOString());
      }
    }
    setValue("invoiceId",searchCriteria.invoiceId);
    if (searchCriteria.fromDate && searchCriteria.toDate) {
      const fromDate = searchCriteria.fromDate || "";
      const toDate = searchCriteria.toDate || "";
      setValue(
        "dateRange",
        fromDate && toDate ? `${fromDate} - ${toDate}` : ""
      );
    } else if (searchCriteria.fromDate) {
      const fromDate = searchCriteria.fromDate || "";
      setValue(
        "dateRange",
        fromDate ? `${fromDate}` : ""
      );
    }
  }

  const invoiceStatusOptions = [
    { label: "PAID", value: "PAID" },
    { label: "UNPAID", value: "UNPAID" }
  ];

  const invoicesStatusOptions = [
    { label: "PARTIAL", value: "PARTIAL" },
    { label: "PAID", value: "PAID" },
    { label: "UNPAID", value: "UNPAID" },
    { label: "PROCESSING", value: "PROCESSING" },
    { label: "CLOSED", value: "CLOSED" }
  ];
  
  const usageStatusOptions = [
    { label: "AVAILABLE", value: "AVAILABLE" },
    { label: "APPLIED", value: "APPLIED" },
    { label: "RETURN INITIATED", value: "RETURN_INITIATED" },
    { label: "RETURN PENDING", value: "RETURN_PENDING" },
    { label: "RETURNED", value: "RETURNED" }
  ];

  const purchaseAndBillOptions = [
    { label: "Yes", value: "Y" },
    { label: "No", value: "N" }
  ];

  // CS-2028 - Aging preset filter. Options/labels and ranges are fully driven by the "InvoiceAging"
  // code table. Each keyName encodes the range as "min#max"; "*" marks an open (unbounded) side and
  // "CUSTOM" has no range.
  const invoiceAgingOptions = useMemo(() => {
    let options: { label: string; value: any }[] = [];
    if (allCodeTablesValuesMap) {
      const values: CodeTable[] = getCodeTableValuesByTableName(allCodeTablesValuesMap, "InvoiceAging");
      values?.forEach((opt) => {
        options.push({ label: opt.displayValue, value: opt.keyName });
      });
    }
    return options;
  }, [allCodeTablesValuesMap]);

  // Reverse-lookup: turn a stored min/max back into its preset key ("min#max", "*" for an open side)
  // or "CUSTOM" when restoring filters.
  const deriveAgingBucket = (min?: string | number, max?: string | number): string[] => {
    const mn = (min ?? "") === "" ? "" : String(min);
    const mx = (max ?? "") === "" ? "" : String(max);
    if (mn === "" && mx === "") return [];
    // Open-ended buckets use the "value#value" convention: "31#31" (>= 31) and "-91#-91" (<= -91).
    let key: string;
    if (mn !== "" && mx === "") {
      key = `${mn}#${mn}`; // only a min set -> open upward
    } else if (mn === "" && mx !== "") {
      key = `${mx}#${mx}`; // only a max set -> open downward
    } else {
      key = `${mn}#${mx}`; // both set -> bounded range
    }
    return [invoiceAgingOptions.some((o) => o.value === key) ? key : "CUSTOM"];
  };

  // "Custom" cannot be combined with the preset buckets: picking it drops the presets, and
  // picking a preset afterwards drops "Custom". Kept here instead of in the shared dropdown.
  const handleAgingChange = (_option: any, value: any) => {
    const selected = Array.isArray(value) ? value : value ? [value] : [];
    const hadCustom = previousAgingRef.current.includes("CUSTOM");
    let normalized = selected;

    if (selected.includes("CUSTOM")) {
      normalized = hadCustom && selected.length > 1
        ? selected.filter((key: string) => key !== "CUSTOM")
        : ["CUSTOM"];
    }

    previousAgingRef.current = normalized;
    if (normalized.length !== selected.length) {
      setValue("invoiceAging", normalized);
    }

    // Presets are sent as invoiceAging keys; the min/max bounds only back "Custom".
    setValue("invoiceAgeMin", "");
    setValue("invoiceAgeMax", "");
  };


  // When manufacturer(s) are selected, only show products belonging to those manufacturers.
  const productOptions = useMemo(() => {
    let options: { label: string; value: number }[] = [];
    if (productsByUserRole && productsByUserRole.length > 0) {
      const filteredByMfg = selectedMfgIds && selectedMfgIds.length > 0
        ? productsByUserRole.filter((product) => selectedMfgIds.includes(Number(product.manufacturerId)))
        : productsByUserRole;
      const sortedProductList: ProductInfo[] = sortNames(filteredByMfg, "productName");
      sortedProductList?.map((option) => {
        const isInactive = option.inactiveDate && dayjs(option.inactiveDate).isBefore(dayjs(), "day");
        options.push({
          label: isInactive ? `${option.productName} (INACTIVE)` : option.productName,
          value: Number(option.productId),
        });
      });
    }
    return options;
  }, [productsByUserRole, selectedMfgIds]);

  useEffect(() => {
    const currentProductIds = (getValues("productIds") || []) as number[];
    if (currentProductIds.length > 0) {
      const validProductIds = currentProductIds.filter((id) =>
        productOptions.some((option) => option.value === Number(id))
      );
      if (validProductIds.length !== currentProductIds.length) {
        setValue("productIds", validProductIds);
      }
    }
  }, [productOptions]);

  const patientsOptions = useMemo(() => {
    let options: { label: string; value: string; patientCode: string }[] = [];
    // When practice(s) are selected, only show patients belonging to those practices.
    const filteredByPractice = selectedPracticeIds && selectedPracticeIds.length > 0
      ? patientsByUserRole?.filter((p: any) => selectedPracticeIds.includes(Number(p.practiceId)))
      : patientsByUserRole;
    filteredByPractice?.map((option: any) => {
      options.push({
        label: fullName(
          "",
          option.firstName,
          option.middleName,
          option.lastName
        ) + " - " + option.birthDate,
        value: option.patientId,
        patientCode: option.patientCode,
      });
    });
    return options;
  }, [patientsByUserRole, selectedPracticeIds]);

  // Clear any selected patients that no longer belong to the selected practice(s)
  useEffect(() => {
    const currentPatientIds = getValues("patientIds") || [];
    if (currentPatientIds.length > 0 && selectedPracticeIds.length > 0) {
      const validPatientIds = currentPatientIds.filter((id: any) =>
        patientsByUserRole?.some(
          (p: any) => Number(p.patientId) === Number(id) && selectedPracticeIds.includes(Number(p.practiceId))
        )
      );
      if (validPatientIds.length !== currentPatientIds.length) {
        setValue("patientIds", validPatientIds);
      }
    }
  }, [selectedPracticeIds]);

    const overAgencyListoptions = useMemo(() => {
      let options: { label: string; value: any }[] = [];
      agencyInfoList
        ?.filter(option => option.commissionType === 'Override')
        .map((option) => {
          options.push({
            label: option.agencyName,
            value: option.agencyId,
          });
        });
      return options;
    }, [agencyInfoList]);

  const practiceList = useMemo(() => {
    // CS - 442 START//
    // if (userInfo.userRole === USER_ROLES.ROLE_PRACTICEADMIN) {
    //   let options: { label: string; value: any }[] = [];
    //   if (practiceByUserRole) {
    //     setValue("practiceIds", [Number(practiceByUserRole[0]?.practiceId)]);
    //     practiceByUserRole.map((item) => {
    //       options.push({ label: item.practiceName, value: item.practiceId });
    //     });
    //   }
    //   return options;
    // } else {
    let options: { label: string; value: any }[] = [
      // { label: "ALL", value: "" },
    ];
    //CS - 442 END 
    if (practiceByUserRole) {
      if (practiceByUserRole?.length > 1) {
        practiceByUserRole.map((item) => {
          options.push({ label: item.practiceName, value: item.practiceId });
        });
      } else {
        setValue("practiceIds", [Number(practiceByUserRole[0]?.practiceId)]);
        practiceByUserRole.map((item) => {
          options.push({ label: item.practiceName, value: item.practiceId });
        });
      }
    }
    return options;
    // }
  }, [practiceByUserRole]);

  const agenciesList = useMemo(() => {
    let options: { label: string; value: any }[] = [];
    if (agencyInfoList) {
      if(agencyInfoList.length > 1) {
      const sortedAgencies: AgencyInfo[] = sortNames(agencyInfoList, 'agencyName');
      sortedAgencies.map((item) => {
        options.push({
          label: item.agencyName,
          value: item.agencyId,
        });
      });
    } else { 
      agencyInfoList.map((item) => {
        options.push({
          label: item.agencyName,
          value: item.agencyId,
        });
      });
      if (
        userInfo.entityName === USER_ROLE_ENTITY_NAMES.AGENCY ||
        userInfo.entityName === USER_ROLE_ENTITY_NAMES.ACCOUNTEXECUTIVE
      ) {
      setValue("agencyIds", [Number(agencyInfoList[0]?.agencyId)]);
      }
    }
    }
    return options;
  }, [agencyInfoList]);

   const manufacturesList = useMemo(() => {
    let options: { label: string; value: any }[] = [];
    if (manufacturerInfoList && manufacturerInfoList.length > 0) {
      manufacturerInfoList.forEach((item) => {
        options.push({
          label: item.manufacturerName,
          value: item.manufacturerId,
        });
      });
      // Fix: Only auto-select if there is exactly one manufacturer and user is MANUFACTURERADMIN or MANUFACTURERSTAFF
      if (
        manufacturerInfoList.length === 1 &&
        (userInfo.entityName === USER_ROLE_ENTITY_NAMES.MANUFACTURER)
      ) {
        setValue("mfgIds", [Number(manufacturerInfoList[0]?.manufacturerId)]);
      }
    }
    return options;
  }, [manufacturerInfoList]);

  // CS-1995 - Product dropdown options for bulk payment are now fetched inside BulkInvoicePayment
  // per selected practice (open-invoice + Stripe-enabled products), replacing the prior client-side
  // productOptionsWithStripe memo.

  /* istanbul ignore next */
  const fetchPracticeListByUserRole = async () => {
    const response = await dispatch(fetchAllUserRoles());
    if (response?.meta?.requestStatus === "fulfilled") {
      if (response?.payload) {
        const useRoles = response.payload;
        const role = useRoles?.find(
          (role: UserRole) => role.roleName === userInfo.userRole
        );
        if (role) {
          dispatch(getPracticeListforFilter());
        }
      }
    }
  };
 useEffect(() => {
    const alertedInvoiceIds = NotificationInfoByRefEntity?.map(notification => notification.entityId);
    if (alertedInvoiceIds) {
      setAlertedInvoiceIds(alertedInvoiceIds);
    }

  }, [NotificationInfoByRefEntity])

   const groupedNotifications = useMemo(() => {
      const map = new Map<number, any[]>();
      NotificationInfoByRefEntity?.forEach((notif) => {
        const invoiceId = notif.entityId;
        if (!map.has(invoiceId)) {
          map.set(invoiceId, []);
        }
        map.get(invoiceId)?.push(notif);
      });
      return map;
    }, [NotificationInfoByRefEntity]);

      const handleStatusClick = (event: React.MouseEvent<HTMLElement>, details: any) => {
    const notificationsForInvoice = groupedNotifications.get(details.invoiceId) || [];

    const popupData = notificationsForInvoice.map((notif) => ({
      notificationId: notif.notificationId,
      description: notif.notificationMsg,
      invoiceNumber: details.mfgInvoiceNumber,
      dateTime: notif.auditTimestamp,
    }));

    setNotificationData(popupData);
    setStatusAnchorEl(event.currentTarget);
  };

   const handleAcknowledge = async (item: any) => {
      try {
        const notificationData = {
          notificationId: item.notificationId,
          comment: ""
        }
        const response = await dispatch(acknowledgeNotification(notificationData)).unwrap();
        if (response.message = "SUCCESS") {
          fetchNotificationsForEntities();
          handleFetchAlerts();
        }
        return response;
      } catch (err) {
        console.error("Failed to fetch wound codes:", err);
        return [];
      }
    }

    const fetchNotificationsForEntities = async () => {
      const invoiceIdList = invoiceList?.content?.map(invoice => Number(invoice.invoiceId));
      const data = {
        notificationTypes: canAccessNotifications && accessibleNotifications ? accessibleNotifications : [],
        refEntityIds:  invoiceIdList ? invoiceIdList : [],
        refEntity: "INVOICE"
      };
  
      if(canAccessNotifications && invoiceIdList){
        const res = await dispatch(fetchNotificationsByRefEntities({ data: data, skipLoader: true }))
        if(res){
          setFetchNotificationsCompleted(true)
        }
      }
    }
  
   const handleFetchAlerts = async () => {
      const data = {
        notificationTypes: accessibleNotifications ? accessibleNotifications: [],
        entity: "INVOICE"
      }
      if(canAccessNotifications){
         const response = await dispatch(fetchAlertEntityNumbers({ data: data, skipLoader: false })).unwrap();
        setTotalNotificationIds(response?.data?.totalNotificationIds)
        setFetchNotificationCountCompleted(true)
      }
    }
    const handleNotification = () => {
    if (!isAlertOnly) {
      if (location.state != null && location.state.invoiceListSearchCriteria != null && location.state.invoiceListSearchCriteria.invoiceId != null) {
        location.state.invoiceListSearchCriteria = {
          ...location.state.invoiceListSearchCriteria,
          invoiceId: null
        }
      }
      setIsAlertOnly(true);
      searchInvoiceList(1,{...getValues(),invoiceId: undefined,alertInvoices:true});
    } else {
      if (location.state != null && location.state.invoiceListSearchCriteria != null && location.state.invoiceListSearchCriteria.invoiceId != null) {
        location.state.invoiceListSearchCriteria = {
          ...location.state.invoiceListSearchCriteria,
          invoiceId: null
        }
      }
      setIsAlertOnly(false);
      searchInvoiceList(1,{...getValues(),invoiceId: undefined,alertInvoices:false});
    }
  }

    useEffect(() => {
      if (userInfo.notificationEnable && canAccessNotifications && 
        accessibleNotifications && accessibleNotifications.length > 0) {
        handleFetchAlerts();
      }
    }, [accessibleNotifications])

     useEffect(() => {
        if(userInfo.notificationEnable){
          fetchNotificationsForEntities();
        }
      }, [invoiceList])
  const handleActionDetails = (row: invoiceTableRow) => {
    const oNumber = row.raworderNumber;
    if (oNumber?.startsWith("M")) {
      navigate("/migrate_billing_detail", { state: { invoiceId: row.invoiceId, orderId: row.orderId } });
    } else {
      navigate("/billing_detail", { state: { invoiceId: row.invoiceId } });
    }
  };

  // CS-1555 - Start
  const handleRowNavigateToDetails = (row: any) => {
    const invoiceRow = row as invoiceTableRow;
    handleActionButtonClick(
      `invoiceListActionButton-${invoiceRow.invoiceId}`,
      () => handleActionDetails(invoiceRow)
    );
  };
  // CS-1555 - End

  // Helper for action button click to save highlight state
  const handleActionButtonClick = (buttonId: string, originalClick: () => void) => {
    const currentPageKey = "invoiceList";
    saveSelectionForPage(currentPageKey, buttonId);
    setActiveButtonId(buttonId);
    sessionStorage.setItem("activeActionButtonId", buttonId);
    originalClick();
  };

  // CS-1532 - Start
  const handleClickInvoiceAudit = (row: invoiceInfo) => {
    if (row && row.mfgInvoiceNumber) {
      const invoiceAuditData = {
        entityName: "INVOICE",
        entiyNumber: row.mfgInvoiceNumber,
      };
      const url = `/auditlog?entityName=${invoiceAuditData.entityName}&entityNumber=${invoiceAuditData.entiyNumber}`;
      window.open(url, "_blank");
    }
  };

  const handleCloseInvoice = (row: invoiceInfo) => {
    setShowOptionsPopup({
      message: `Do you really want to close this invoice?`,
      show: true,
      variant: "confirm",
      buttons: [
        {
          name: "Confirm",
          color: "primary",
          onClick: () => handleChangeStatusToClosed(row),
        },
        {
          name: "Cancel",
          color: "secondary",
          onClick: () => setShowOptionsPopup({ message: "", show: false }),
        },
      ],
    });
  };

  const handleChangeStatusToClosed = async (row: invoiceInfo) => {
    const resp = await dispatch(
      changeInvoiceStatus({
        data: {
          invoiceId: row.invoiceId,
          mfgInvoiceStatus: "CLOSED",
        },
        interceptorOption: {},
      })
    );
    if (resp.meta.requestStatus === "fulfilled") {
      const alertObj: SingleAlertInfo = {
        message: `Invoice ${row.mfgInvoiceNumber} closed successfully`,
        alertType: "success",
      };
      dispatch(setSingleAlertObj(alertObj));
      searchInvoiceList(1, { ...getValues() });
    } else {
      const alertObj: SingleAlertInfo = {
        message: "Something went wrong",
        alertType: "error",
      };
      dispatch(setSingleAlertObj(alertObj));
    }
    setShowOptionsPopup({ message: "", show: false });
  };
  // CS-1532 - End

  const onSubmit = (data: SearchInvoiceInfo) => {
    if (!isDateRangeChanged) {
      setIsClearDateRange(true);
    }
    const { checkBox, selectAllCheckBox, ...submitObj } = data;
    submitObj.currentPage = 1;
    submitObj.fromDate = isDateRangeChanged ? getValues("fromDate") : "";
    submitObj.toDate = isDateRangeChanged ? getValues("toDate") : "";
    const criteria = invoiceListSort.normalize(submitObj);
    navigate("/invoice_list", { state: { invoiceListSearchCriteria: criteria } });
  };

  const handleColumnToggleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleColumnToggleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const pagination = (pageNumber: number) => {
    let obj = getValues();
    obj.currentPage = pageNumber + 1;
    navigate("/invoice_list", { state: { invoiceListSearchCriteria: obj } });
    setValue('selectAllCheckBox', false);
    formattedInvoiceRows?.map(row => {
      //@ts-ignore
      setValue(`checkBox.invoice_${row.invoiceId}`, false);
    });
    setSelectedMfgAndPractice({ manufacturerId: null, practiceId: null });
  };

  const handleTableSort = (columnId: string, order: "asc" | "desc") => {
    const next = invoiceListSort.withSort(getValues(), columnId, order);
    if (!next) {
      return;
    }
    setValue("sortBy", next.sortBy);
    setValue("sortOrder", next.sortOrder);
    setValue("currentPage", 1);
    navigate("/invoice_list", { state: { invoiceListSearchCriteria: next } });
  };

  const checkboxComponent = (row: invoiceInfo): JSX.Element => {
    // Check if a selection exists
    const hasSelection = selectedMfgAndPractice.manufacturerId !== null && 
                        selectedMfgAndPractice.practiceId !== null;
    
    // Check if this row matches the current selection
    const isMatchingSelection = hasSelection &&
      selectedMfgAndPractice.manufacturerId === row.manufacturerId && 
      selectedMfgAndPractice.practiceId === row.practiceId;
    
    // Disable if a different manufacturer+practice combination is selected
    const shouldDisable = hasSelection && !isMatchingSelection;

    return (
      <Box
        onClick={(e) => e.stopPropagation()}
      >
        <CustomCheckbox
          control={control}
          color="primary"
          controllerName={`checkBox.invoice_${row.invoiceId}`}
          onChange={(e) =>
            handleActionButtonClick(
              `invoiceListActionButton-${row.invoiceId}`,
              () => handleCheckbox(e, row.manufacturerId, row.practiceId, row.invoiceId)
            )
          }
          isDisabled={shouldDisable}
        />
      </Box>
    );
  };

  const handleCheckbox = (
    e: React.ChangeEvent<HTMLInputElement>,
    manufacturerId: number,
    practiceId: number,
    invoiceId: number
  ) => {
    const { checked } = e.target;
    
    if (checked) {
      // When checking a checkbox, set the manufacturer+practice combination
      setSelectedMfgAndPractice({ manufacturerId, practiceId });
    } else {
      // When unchecking, check if any other checkboxes are still checked
      const checkBoxValues = getValues('checkBox') || {};
      
      // Filter out the current checkbox and check if any others are checked
      const otherCheckedBoxes = Object.entries(checkBoxValues).filter(
        ([key, value]) => key !== `invoice_${invoiceId}` && value === true
      );
      
      if (otherCheckedBoxes.length === 0) {
        // No other checkboxes are checked, clear the selection
        setValue("selectAllCheckBox", false);
        setSelectedMfgAndPractice({ manufacturerId: null, practiceId: null });
      }
      // If other checkboxes are still checked, keep the selection active
    }
  };
  // CS-416 Invoice List UI Header modifications
  const columnsInvoice: Column[] = [
    // {
    //   id: "checkBox", label: (
    //     <Box
    //       onClick={(e) => e.stopPropagation()}
    //       >
    //     <CustomCheckbox
    //       control={control}
    //       controllerName="selectAllCheckBox"
    //       isDisabled={selectedMfgAndPractice.manufacturerId === null || selectedMfgAndPractice.practiceId === null}
    //       onChange={(e) => handleSelectAllCheckBox(e)}
    //       sx={{ align: "center" }}
    //     />
    //     </Box>
    //   ),
    // },
    // { id: "mfgInvoiceNumber", label: "INV ID", align: "left" },
    { id: "mfgInvoiceNumberLink", label: "INV ID", align: "left" }, //CS-1406 - Rendering Invoice number with link
    { id: "mfgInvoiceDate", label: "INV Date", align: "left" },
    { id: "invoiceDueDate", label: "INV Due Date",  align: "left" },
    { id: "invoiceLateDays", label: "INV Aging", align: "left" },
    { id: "orderNumber", label: "Order ID",  align: "left" }, //CS-1141 Changes
    { id: "manufacturerName", label: "MFR",  align: "left" },
    { id: "practiceName", label: "Practice", align: "left" },
    { id: "invoiceAmount", label: "Invoice Total",  align: "left" },//CS-1513 - Changes
    { id: "remainingAmount", label: "Outstanding Amt",  align: "left" },//Cs-1458 - Changes
    { id: "customInvoiceStatus", label: "Status",  align: "left" },
    // { id: "invoiceStatus", label: "Status",  align: "left" },
    {id: "action", label: "Action"},
  ];

  // const handleCheckout = async () => {
  
  //     try {
  //       const data = {
  //         amount: 560000, // Amount in cents
  //         currency: "usd",
  //       };
  //       const response = await dispatch(stripeCheckOutPaymentData(data)).unwrap();
  //       const checkoutUrl = response.checkoutUrl || response.data?.checkoutUrl; // check based on your response structure
  
  //       if (checkoutUrl) {
  //         // Redirect user to Stripe-hosted Checkout page
  //         window.location.href = checkoutUrl;
  //       } else {
  //       return ("Error: Checkout URL not found in response.");
  //       }
  //     } catch (err) {
  //       return err;
  //     } finally {
  //       return;
  //     }
  //   };

    //CS-1576 - Enabling the partial payment in stripe
  const handleCheckout = async (invoiceId: number, paymentMethodType: string, paymentType: string,paymentAmount: number) => {
    const data = {
      returnPath: location.pathname + location.search,
      invoiceId: invoiceId,
      paymentMethod: paymentMethodType,
      invoiceLineItemList: [
        {
          invoiceId: invoiceId,
          paymentAmt: paymentAmount,
          paymentType: paymentType,
        }
      ],
    };
    await dispatch(stripeCheckOutPaymentData(data)).then((res) => {
    //CS-1563
    if (res && res?.payload) {
      if (res.payload.errors && res.payload.errors.length > 0) {
        const errorMessage = res.payload.errors[0].errorMessage;
        const alertObj: SingleAlertInfo = {
          message: errorMessage,
          alertType: "error",
        };
        dispatch(setSingleAlertObj(alertObj));
      } else if (res.payload.data) {
        const checkoutUrl = res.payload.data.checkoutUrl;
        if (checkoutUrl) window.location.href = checkoutUrl;
      }
    }
    }).catch((error)=>{
      console.log(error);
    }); 
  };

  const handleClickLateFee = (row: invoiceInfo) => {
    setSelectedInvoiceId(row.invoiceId);
    setIsPopupOpen(true);
    setLateFeeAmount(row?.lateFee ?? 0);
  };

  const toOverridePayoutInvoice = (invoice: invoiceInfo): OverridePayoutInvoice => ({
    invoiceId: Number(invoice.invoiceId),
    mfgInvoiceNumber: String(invoice.mfgInvoiceNumber ?? ""),
    mfgInvoiceDate: String(invoice.mfgInvoiceDate ?? ""),
    invoiceAmount: Number(invoice.invoiceAmount) || 0,
    invoiceStatus: String(invoice.invoiceStatus ?? ""),
    overrideAgencyName: invoice.overrideAgencyName ? String(invoice.overrideAgencyName) : undefined,
  });

  const invoiceHasOverridePayout = (row: invoiceTableRow) => {
    const source = invoiceList?.content?.find((invoice) => invoice.invoiceId === row.invoiceId) ?? row;
    return Boolean(
      source.overrideAgencyId ||
      (source.overrideAgencyName && String(source.overrideAgencyName).trim()) ||
      Number(source.expectedOvrAmt) > 0 ||
      Number(source.ovrAgencyCommissionAmount) > 0 ||
      Number(source.ovrAgencyCommissionPaidAmount) > 0
    );
  };

  const openOverridePayout = (row: invoiceTableRow) => {
    const clicked = invoiceList?.content?.find((invoice) => invoice.invoiceId === row.invoiceId);
    const checkedIds = Object.entries(getValues("checkBox") || {})
      .filter(([, isChecked]) => isChecked)
      .map(([key]) => {
        const match = key.match(/invoice_(\d+)/);
        return match ? Number(match[1]) : NaN;
      })
      .filter((id) => Number.isFinite(id));
    const selectedIds = checkedIds.length > 0 ? checkedIds : [row.invoiceId];
    const selected = selectedIds
      .map((id) => invoiceList?.content?.find((invoice) => invoice.invoiceId === id))
      .filter((invoice): invoice is invoiceInfo => Boolean(invoice));
    const invoices = (selected.length > 0 ? selected : clicked ? [clicked] : []).map(toOverridePayoutInvoice);
    if (invoices.length === 0) {
      dispatch(setSingleAlertObj({
        message: "Please select at least one invoice.",
        alertType: "error",
      }));
      return;
    }
    setOverridePayoutInvoices(invoices);
  };

  const handleCloseOverridePayout = () => setOverridePayoutInvoices(null);

  const handleOverridePayoutRecorded = () => {
    setOverridePayoutInvoices(null);
    searchInvoiceList(getValues("currentPage") || 1, { ...getValues() });
  };

  const toAgencyPayoutInvoice = (invoice: invoiceInfo): AgencyPayoutInvoice => ({
    invoiceId: Number(invoice.invoiceId),
    mfgInvoiceNumber: String(invoice.mfgInvoiceNumber ?? ""),
    mfgInvoiceDate: String(invoice.mfgInvoiceDate ?? ""),
    invoiceAmount: Number(invoice.invoiceAmount) || 0,
    invoiceStatus: String(invoice.invoiceStatus ?? ""),
    agencyName: invoice.agencyName ? String(invoice.agencyName) : undefined,
  });

  const invoiceHasAgencyPayout = (row: invoiceTableRow) => {
    const source = invoiceList?.content?.find((invoice) => invoice.invoiceId === row.invoiceId) ?? row;
    return Boolean(
      source.agencyId ||
      (source.agencyName && String(source.agencyName).trim()) ||
      Number(source.expectedAgencyAmt) > 0 ||
      Number(source.agencyCommissionAmount) > 0 ||
      Number(source.agencyCommissionPaidAmount) > 0
    );
  };

  const invoiceCanEditServiceFee = (row: invoiceTableRow) => {
    const source = invoiceList?.content?.find((invoice) => invoice.invoiceId === row.invoiceId) ?? row;
    return invoiceHasServiceFeePayment(source);
  };

  const openAgencyPayout = (row: invoiceTableRow) => {
    const clicked = invoiceList?.content?.find((invoice) => invoice.invoiceId === row.invoiceId);
    const checkedIds = Object.entries(getValues("checkBox") || {})
      .filter(([, isChecked]) => isChecked)
      .map(([key]) => {
        const match = key.match(/invoice_(\d+)/);
        return match ? Number(match[1]) : NaN;
      })
      .filter((id) => Number.isFinite(id));
    const selectedIds = checkedIds.length > 0 ? checkedIds : [row.invoiceId];
    const selected = selectedIds
      .map((id) => invoiceList?.content?.find((invoice) => invoice.invoiceId === id))
      .filter((invoice): invoice is invoiceInfo => Boolean(invoice));
    const invoices = (selected.length > 0 ? selected : clicked ? [clicked] : []).map(toAgencyPayoutInvoice);
    if (invoices.length === 0) {
      dispatch(setSingleAlertObj({
        message: "Please select at least one invoice.",
        alertType: "error",
      }));
      return;
    }
    setAgencyPayoutInvoices(invoices);
  };

  const handleCloseAgencyPayout = () => setAgencyPayoutInvoices(null);

  const handleAgencyPayoutRecorded = () => {
    setAgencyPayoutInvoices(null);
    searchInvoiceList(getValues("currentPage") || 1, { ...getValues() });
  };

  const openServiceFeeEdit = async (row: invoiceTableRow, kind: ServiceFeeKind) => {
    const source = invoiceList?.content?.find((invoice) => invoice.invoiceId === row.invoiceId) ?? row;
    const result = await resolveServiceFeeAmountEdit(
      dispatch,
      allCodeTablesValuesMap,
      {
        invoiceId: Number(source.invoiceId),
        mfgInvoiceNumber: source.mfgInvoiceNumber,
        orderNumber: typeof source.orderNumber === "string" || typeof source.orderNumber === "number" ? source.orderNumber : source.raworderNumber,
        invoiceAmount: source.invoiceAmount,
        agencyId: source.agencyId,
        overrideAgencyId: source.overrideAgencyId,
      },
      kind
    );
    if (!result.ok) {
      dispatch(setSingleAlertObj({ message: result.message, alertType: "error" }));
      return;
    }
    setServiceFeeEdit(result.target);
  };

  const handleServiceFeeUpdate = async (data: any) => {
    const edit = serviceFeeEdit;
    const outcome = await saveServiceFeeAmountEdit(dispatch, data, edit?.label || "Service fee");
    dispatch(setSingleAlertObj({ message: outcome.message, alertType: outcome.ok ? "success" : "error" }));
    setServiceFeeEdit(null);
    if (outcome.ok && !outcome.unchanged) {
      searchInvoiceList(getValues("currentPage") || 1, { ...getValues() });
    }
  };

  const handleOpenPaymentInstructionDoc = async (row: invoiceTableRow | invoiceInfo) => {
    const actionResult = await dispatch(fetchDocumentById(row.paymentInstructionValue ?? ""));
    const documentData = actionResult.payload;
    
    if (documentData && documentData.content) {
      setPDFContent(documentData.content);
      setShowPDF({ isShow: true, noteName: "Payment Instruction - " + row.manufacturerName, fileName: "Payment Instruction_" + row.manufacturerName });
    };
  }
  
  const actionComponent = (row: invoiceTableRow): JSX.Element => {
    return (
      <>
        <CustomIconButton
          color="info"
          tooltipMessage="Detail"
          tooltipPlacement="top"
          variant="outlined"
          size="small"

          onClick={(e?: React.MouseEvent) => { if (e) e.stopPropagation(); handleActionButtonClick(`invoiceListActionButton-${row.invoiceId}`, () => handleActionDetails(row)) }}
        >
          <ListAltOutlined fontSize="small" />
        </CustomIconButton>
        {/* CS-2187 - Same Update Invoice visibility as billing detail */}
        <CustomIconButton
          color="info"
          tooltipMessage="Update Invoice"
          tooltipPlacement="top"
          variant="outlined"
          size="small"
          style={{ display: `${hideElement(!canShowUpdateInvoice(row, canAccessEditInvoiceAction))}` }}
          onClick={(e?: React.MouseEvent) => {
            if (e) e.stopPropagation();
            handleActionButtonClick(`invoiceListActionButton-${row.invoiceId}`, () =>
              navigate("/edit_invoice", { state: row.invoiceId })
            );
          }}
        >
          <ModeOutlined fontSize="small" />
        </CustomIconButton>

        <CustomIconButton
          color="info"
          tooltipMessage="Activity Center"
          tooltipPlacement="top"
          variant="outlined"
          size="small"
          style={{ display: `${hideElement(!canAccessActivityCenter)}` }}
          onClick={(e?: React.MouseEvent) => {
            if (e) e.stopPropagation();
            navigate(buildActivityCenterPath({
              tab: "invoice",
              invoiceId: row.invoiceId,
              invoiceNumber: asEntityNumber(row.mfgInvoiceNumber) || asEntityNumber((row as any).rawMfgInvoiceNumberLink),
              orderId: row.orderId,
              orderNumber: asEntityNumber((row as any).raworderNumber) || asEntityNumber(row.orderNumber),
            }));
          }}
        >
          <HistoryOutlined fontSize="small" />
        </CustomIconButton>

        <CustomIconButton
          color="warning"
          tooltipMessage="Record Credit Memo"
          tooltipPlacement="top"
          variant="outlined"
          size="small"
          style={{ display: `${hideElement(!canAccessRecordCreditMemoAction || row.invoiceStatus === 'PAID' || row.invoiceStatus === 'CLOSED')}` }}
          onClick={() => handleActionButtonClick(`invoiceListActionButton-${row.invoiceId}`, 
            () => navigate("/record_credit_memo", { state: { invoiceId: row.invoiceId, invNumber: row.mfgInvoiceNumber, invAmt: row.invoiceAmount, invDate: row.mfgInvoiceDate, practice: row.practiceName, agency: row.agencyName, mfr: row.manufacturerName } }))}
        >
          <CreditCard fontSize="small" />
        </CustomIconButton>
        {/* {row?.stripeConfig?.stripe_integration !== 'Y' && ( */}
        <CustomIconButton
          color="success"
          tooltipMessage="Record Payment"
          tooltipPlacement="top"
          variant="outlined"
          size="small"
          style={{ display: `${hideElement(!canAccessAddPaymentAction || row.invoiceStatus === 'PAID' || row.invoiceStatus === 'CLOSED')}` }}
          onClick={() => handleActionButtonClick(`invoiceListActionButton-${row.invoiceId}`,
            () =>  navigate("/record_payment", { state: { invoiceId: row.invoiceId, invNumber: row.mfgInvoiceNumber, invAmt: row.invoiceAmount, invDate: row.mfgInvoiceDate, practice: row.practiceName, agency: row.agencyName, mfr: row.manufacturerName ,invoiceAmount:row.invoiceAmount ,creditAmount:row.creditAmount} }))}
        >
          <AttachMoney fontSize="small" />
        </CustomIconButton>
        <CustomIconButton
          color="secondary"
          tooltipMessage="Record OVR Payout"
          tooltipPlacement="top"
          variant="outlined"
          size="small"
          aria-label="Record OVR Payout"
          style={{ display: `${hideElement(!canAccessCreateOVRAGYPayout || !invoiceHasOverridePayout(row))}` }}
          onClick={(e?: React.MouseEvent) => {
            if (e) e.stopPropagation();
            handleActionButtonClick(`invoiceListActionButton-${row.invoiceId}`, () => openOverridePayout(row));
          }}
        >
          <PaymentsOutlined fontSize="small" />
        </CustomIconButton>
        <CustomIconButton
          color="info"
          tooltipMessage="Record AGY Payout"
          tooltipPlacement="top"
          variant="outlined"
          size="small"
          aria-label="Record AGY Payout"
          sx={{ color: "#0288d1", borderColor: "#0288d1", "&:hover": { borderColor: "#0288d1", backgroundColor: "rgba(2,136,209,0.12)" } }}
          style={{ display: `${hideElement(!canAccessCreateAGYPayout || !invoiceHasAgencyPayout(row))}` }}
          onClick={(e?: React.MouseEvent) => {
            if (e) e.stopPropagation();
            handleActionButtonClick(`invoiceListActionButton-${row.invoiceId}`, () => openAgencyPayout(row));
          }}
        >
          <PaymentsOutlined fontSize="small" />
        </CustomIconButton>
        <CustomIconButton
          color="info"
          tooltipMessage="Edit AGY Service Fee Amount"
          tooltipPlacement="top"
          variant="outlined"
          size="small"
          aria-label="Edit AGY Service Fee Amount"
          style={{ display: `${hideElement(!canEditCommissionRate || !invoiceHasAgencyPayout(row) || !invoiceCanEditServiceFee(row))}` }}
          onClick={(e?: React.MouseEvent) => {
            if (e) e.stopPropagation();
            handleActionButtonClick(`invoiceListActionButton-${row.invoiceId}`, () => {
              void openServiceFeeEdit(row, "AGENCY");
            });
          }}
        >
          <EditOutlined fontSize="small" />
        </CustomIconButton>
        <CustomIconButton
          color="secondary"
          tooltipMessage="Edit OVR Service Fee Amount"
          tooltipPlacement="top"
          variant="outlined"
          size="small"
          aria-label="Edit OVR Service Fee Amount"
          style={{ display: `${hideElement(!canEditCommissionRate || !invoiceHasOverridePayout(row) || !invoiceCanEditServiceFee(row))}` }}
          onClick={(e?: React.MouseEvent) => {
            if (e) e.stopPropagation();
            handleActionButtonClick(`invoiceListActionButton-${row.invoiceId}`, () => {
              void openServiceFeeEdit(row, "OVERRIDE");
            });
          }}
        >
          <EditOutlined fontSize="small" />
        </CustomIconButton>
         {/* )} */}
       {/* CS-1375 - Start */}
        {row?.stripeConfig && (
          (
            (row?.stripeConfig?.stripe_integration === 'Y' && canCreateStripePayment) ||
            (row?.stripeConfig?.stripe_integration === 'N' && row?.hasPaymentInstruction)
          ) && (
            <CustomIconButton
              tooltipMessage={row?.stripeConfig?.stripe_integration === 'Y' ? "Pay via Stripe" : "Payment Instruction"}
              tooltipPlacement="top"
              variant="contained"
              size="small"
              color={row?.stripeConfig?.stripe_integration === 'Y' ? undefined : "warning"}
              style={{ 
                display: `${hideElement(row.invoiceStatus === 'PAID'  || row.invoiceStatus === 'CLOSED')}`,
                // CS-1682 - Stripe purple color optimized for visibility on highlighted rows
                ...(row?.stripeConfig?.stripe_integration === 'Y' && {
                  color: "white",
                  borderColor: theme.palette.mode === 'dark' ? "#c374ff" : "#c374ff",
                  background: theme.palette.mode === 'dark' 
                    ? "linear-gradient(135deg, #6366f1, #8b5cf6, #a855f7, #ec4899)"
                    : "linear-gradient(135deg, #4f46e5, #7c3aed, #9333ea, #db2777)",
                })
              }}
              onClick={() => handleActionButtonClick(`invoiceListActionButton-${row.invoiceId}`, () => {
                // Check if Stripe is enabled
                if (row?.stripeConfig?.stripe_integration === 'Y') {
                  // CS-1458 - Handling zero outstanding amount case for Pay Now
                  if (row?.outstandingAmount && Number(row?.outstandingAmount) > 0) {
                    setShowStripePaymentTypePopup(true);
                    setSelectedInvoiceData(row);
                  } else {
                    let errObj: SingleAlertInfo = {
                      message: "This invoice currently shows 'Unpaid,' but the outstanding amount due is 0. It was likely settled by credits or adjustments, so no payment is needed.",
                      alertType: "error"
                    };
                    dispatch(setSingleAlertObj(errObj));
                  }
                } else if (row?.hasPaymentInstruction) {
                  // Stripe is disabled but payment instruction exists
                  if (row?.paymentInstructionType === 'Product Document' && row?.paymentInstructionValue) {
                    if (row?.paymentInstructionValue?.startsWith('https://') || row?.paymentInstructionValue?.startsWith('http://')) {
                      window.open(row.paymentInstructionValue, '_blank');
                    } else {
                      handleOpenPaymentInstructionDoc(row);
                    }
                  } else if (row?.paymentInstructionType === 'External URL' && row?.paymentInstructionValue) {
                    // Redirect to external link
                    window.open(row.paymentInstructionValue, '_blank');
                  }
                }
              })}
            >
                <AttachMoney fontSize="small" />
            </CustomIconButton>
          ))}
        {/* CS-1532 - Start */}
        <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="Close Invoice"
          color="error"
          size="small"
          variant="outlined"
          style={{ display: `${hideElement(!(canAccessCloseInvoiceAction && row.invoiceStatus === 'UNPAID'))}` }}
          onClick={() =>
            handleActionButtonClick(
              `invoiceListActionButton-${row.invoiceId}`,
              () => handleCloseInvoice(row)
            )
          }
        >
          <CloseOutlined fontSize="small" />
        </CustomIconButton>
        <CustomIconButton
          color="success"
          tooltipMessage="Late Fee"
          tooltipPlacement="top"
          variant="outlined"
          size="small"
          onClick={() => handleClickLateFee(row)}
          style={{ display: `${hideElement(!canLateFeeAction || row.invoiceStatus === 'PAID' || row.invoiceStatus === 'CLOSED')}` }}
        >
          <CurrencyExchangeOutlined fontSize="small" />
        </CustomIconButton>
        <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="Invoice Audit"
          color="warning"
          size="small"
          variant="outlined"
          style={{ display: `${hideElement(!canAuditInvoice || row.manufacturerName === 'Migrate Manufacturer')}` }}
          onClick={() => handleActionButtonClick(`invoiceListActionButton-${row.invoiceId}`, () => handleClickInvoiceAudit(row))}
        >
          <TrackChanges fontSize="small" />
        </CustomIconButton>
        {/* CS-1532 - End */}
      </>
    );
  };
  const displayCheckboxConditional = (row: any) => {
    const isStripeEnabled = row?.stripeConfig?.stripe_integration === 'Y';
    const isPartialOrUnpaid = row?.invoiceStatus === "PARTIAL" || row?.invoiceStatus === "UNPAID";
    const hasOutstandingAmount = Number(row?.remainingAmount ?? 0) > 0;

    if (isStripeEnabled && isPartialOrUnpaid && hasOutstandingAmount) {
      return checkboxComponent(row);
    }

    return "";
  }

  // Get selected invoice IDs
  const selectedInvoiceIds = useMemo(() => {
    const values = checkBoxValues;
    
    if (!values || typeof values !== 'object') {
      console.log('Invalid checkBoxValues for IDs:', values);
      return [];
    }
    
    // Extract invoice IDs from checked checkboxes
    const ids = Object.keys(values)
      .filter(key => values[key] === true)
      .map(key => {
        // Match pattern: checkBox.invoice_123 or invoice_123
        const match = key.match(/invoice_(\d+)/);
        return match ? parseInt(match[1], 10) : null;
      })
      .filter((id): id is number => id !== null);
    
    // Debug logging
    console.log('Checkbox values for IDs:', values);
    console.log('Extracted invoice IDs:', ids);
    
    return ids;
  }, [JSON.stringify(checkBoxValues)]);

  const formattedInvoiceRows: invoiceTableRow[] | [] = useMemo(() => {
    let formatRows: invoiceTableRow[] = [];
    invoiceList?.content?.map((row) => {
    //CS-1458 - Adding Pay Now button next to Outstanding Amount
    const remainingAmountRaw = Number(row?.remainingAmount ?? 0);
const remainingAmountCell = (
  //CS-1513 - Aligned the pay now button with amount 
  <Grid
    container
    wrap="nowrap"            
    alignItems="center"       
    columnGap={1}             
  >
    <Grid item xs zeroMinWidth>
      <Typography noWrap>
        {priceFormatter(remainingAmountRaw)}
      </Typography>
    </Grid>

    {row?.stripeConfig && (
      (
        (row?.stripeConfig?.stripe_integration === 'Y' && canCreateStripePayment) ||
        (row?.stripeConfig?.stripe_integration === 'N' && row?.hasPaymentInstruction)
      ) && (
        <Grid item>
          <CustomIconButton
            tooltipMessage={row?.stripeConfig?.stripe_integration === 'Y' ? "Pay via Stripe" : "Payment Instruction"}
            tooltipPlacement="top"
            variant="contained"
            size="small"
            color={row?.stripeConfig?.stripe_integration === 'Y' ? undefined : "warning"}
            style={{
              display: hideElement(row.invoiceStatus === "PAID"  || row.invoiceStatus === 'CLOSED'),
              // CS-1682 - Stripe purple color optimized for visibility on highlighted rows
              ...(row?.stripeConfig?.stripe_integration === 'Y' && {
              color: "white",
                  borderColor: theme.palette.mode === 'dark' ? "#c374ff" : "#c374ff",
                  background: theme.palette.mode === 'dark' 
                    ? "linear-gradient(135deg, #6366f1, #8b5cf6, #a855f7, #ec4899)"
                    : "linear-gradient(135deg, #4f46e5, #7c3aed, #9333ea, #db2777)",
              })
            }}
            onClick={(e) => {
              e.stopPropagation(); // CS-1555
              handleActionButtonClick(`invoiceListActionButton-${row.invoiceId}`, () => {
                // Check if Stripe is enabled
                if (row?.stripeConfig?.stripe_integration === 'Y') {
                  // CS-1458 - Handling zero outstanding amount case for Pay Now
                  if (remainingAmountRaw > 0) {
                    setShowStripePaymentTypePopup(true);
                    setSelectedInvoiceData(formatRow);
                  } else {
                    dispatch(setSingleAlertObj({
                      message:
                        "This invoice currently shows 'Unpaid,' but the outstanding amount due is 0. It was likely settled by credits or adjustments, so no payment is needed.",
                      alertType: "error",
                    }));
                  }
                } else if (row?.hasPaymentInstruction) {
                  // Stripe is disabled but payment instruction exists
                  // CS-1651 start
                  if (row?.paymentInstructionType === 'Product Document') {
                    //check whether is a URL or Document
                    if (row?.paymentInstructionValue?.startsWith('https://') || row?.paymentInstructionValue?.startsWith('http://')) {
                      // Redirect to external link
                      window.open(row.paymentInstructionValue, '_blank');
                    } else if (row?.paymentInstructionValue) {
                      // Open PDF document
                      handleOpenPaymentInstructionDoc(row);
                    }
                    // CS-1651 end
                  } else if (row?.paymentInstructionType === 'External URL' && row?.paymentInstructionValue) {
                    // Redirect to external link
                    window.open(row.paymentInstructionValue, '_blank');
                  }
                }
              })
            }}
          >
              <AttachMoney fontSize="small" />
          </CustomIconButton>
        </Grid>
      )
    )}
  </Grid>
);
      let formatRow: invoiceTableRow = {
        ...row,
        //CS-1406 - Rendering mfg invoice number  link
        mfgInvoiceNumberLink: row?.invoiceId !== null ? (
          <Box display="flex" alignItems="center" gap={1}>
            <Link
              component="button"
              underline="hover"
              variant="body2"
              // CS-1555 - Start
              onClick={(e) => {
                e.stopPropagation(); handleActionButtonClick(`invoiceListActionButton-${row.invoiceId}`, () => handleActionDetails({...row}))
              }}
              // CS-1555 - End
              color={'#00B8D9'}
            >
              {row?.mfgInvoiceNumber}
            </Link>
            {row.isUpfrontOrder && (
              <BoltOutlined
                sx={{ fontSize: 20, color: "#00E5B0" }}
                titleAccess="Upfront Invoice"
              />
            )}
          </Box>
        ) : (
          <Box display="flex" alignItems="center" gap={1}>
            {row?.mfgInvoiceNumber}
            {row.isUpfrontOrder && (
              <BoltOutlined
                sx={{ fontSize: 20, color: "#00E5B0" }}
                titleAccess="Upfront Invoice"
              />
            )}
          </Box>
        ),
        rawMfgInvoiceNumberLink: row.mfgInvoiceNumber, // CS-1517
        invoiceLateDays: renderDynamicAgingColumn(row),
        rawInvoiceLateDays: row?.invoiceLateDays , //CS-1588 -  Added for sorting
        orderNumber: row.orderNumber !== null ? (
          <Link
            component="button"
            underline="hover"
            variant="body2"
            // CS-1555 - Start
            onClick={(e) => {
              e.stopPropagation();
              handleActionButtonClick(`invoiceListActionButton-${row.invoiceId}`, () =>
                handleOrderListNavigate(row)
              );
            }}
            // CS-1555 - End
            style={{ color: colors.info[300] }}
          >
            {row.orderNumber}
          </Link>
        ) : (
          row.orderNumber || ''
        ),
        raworderNumber:row.orderNumber,
        invoiceAmount: priceFormatter(Number(row.invoiceAmount)),
        creditAmount: priceFormatter(Number(row.creditAmount ? row.creditAmount : 0)),
        // checkBox: displayCheckboxConditional(row),
        manufacturerName: row.manufacturerName !== 'Migrate Manufacturer' ? row.manufacturerName : '-',
        // customInvoiceStatus:row?.invoiceStatus,
        invoiceStatus: row?.invoiceStatus,
    //CS-1458 - Adding Pay Now button next to Outstanding Amount
        remainingAmount:  remainingAmountCell ,
        actualRemainingAmount: remainingAmountRaw,
        outstandingAmount: remainingAmountRaw,
    //CS-1458 - End
        // remainingAmount: (<>
        // {row?.remainingAmount ? priceFormatter(Number(row.remainingAmount)) : priceFormatter(Number(0))}
        //   {row?.customConfig && row?.stripeConfig?.stripe_integration === 'Y' && canCreateStripePayment && (
        //     <CustomIconButton
        //       color="warning"
        //       tooltipMessage="Pay Now"
        //       tooltipPlacement="top"
        //       variant="outlined"
        //       size="small"
        //       style={{ display: `${hideElement(row.invoiceStatus === 'PAID' || row.invoiceStatus === 'PROCESSING')}` }}
        //       onClick={() => handleActionButtonClick(`invoiceListActionButton-${row.invoiceId}`, () => {
        //         //CS-1458 - Handling zero outstanding amount case for Pay Now
        //         if (row?.outstandingAmount && Number(row?.outstandingAmount) > 0) {
        //           setShowStripePaymentTypePopup(true); setSelectedInvoiceData(row);
        //         } else {
        //           let errObj: SingleAlertInfo = {
        //             message: "This invoice currently shows ‘Unpaid,’ but the outstanding amount due is 0. It was likely settled by credits or adjustments, so no payment is needed.",
        //             alertType: "error"
        //           };
        //           dispatch(setSingleAlertObj(errObj));
        //         }
        //       })} // handleCheckout(row);

        //     >
        //       <AttachMoney fontSize="small" />
        //     </CustomIconButton>
        //   )}
        // </>),//CS-1458 - Change
        // outstandingAmount:row?.remainingAmount ,//CS-1458 - Change
        customInvoiceStatus:userInfo.notificationEnable && row?.stripeConfig?.stripe_integration === 'Y'? (
                  <Box display="flex" alignItems="center" gap={1}>
                    {alertedInvoiceIds.includes(row.invoiceId) && (
                      <Box
                        onClick={(e) => { e.stopPropagation(); handleStatusClick(e, row) }}
                        sx={{
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          backgroundColor: rederDynamicStatusColor(row?.invoiceStatus),
                          // backgroundColor: row?.invoiceStatus === "PAID" || row?.invoiceStatus === "PARTIAL" ? "#1aa457" : "#d12626ff",
                          display: "inline-block",
                          cursor: "pointer",
                        }}
                      />
                    )}
                    <Typography variant="body2" sx={{ display: "inline-block" }}>
                      {row.invoiceStatus}
                    </Typography>
                  </Box>
                ) : (
                 row.invoiceStatus
                )
      };
      formatRows.push(formatRow);
    });
    return formatRows;
  }, [invoiceList, getValues()]);

  // Get selected invoice data
  const selectedInvoices = useMemo(() => {
    return formattedInvoiceRows.filter(row => 
      selectedInvoiceIds.includes(row.invoiceId)
    );
  }, [formattedInvoiceRows, selectedInvoiceIds]);
  //static data
const sampleData = [
  {
    invoiceId: 1434,
    mfgInvoiceNumber: "INV2026022002",
    actualRemainingAmount: 56524.32,
    stripeConfig: {
      platform_fee_card_additional: "0.3",
      stripe_integration: "Y",
      platform_fee_applicable: "Y",
      platform_fee_us_bank_account_max_charge: "5",
      connected_account_id: "acct_1SPfmkH8KVcXtDPF",
      platform_fee_card_percent: "2.9",
      platform_fee_us_bank_account_percent: "0.8",
      payment_method: "US_BANK_ACCOUNT,CARD"
    },
    manufacturerStripeConfig: {
      platform_fee_card_additional: "0.3",
      stripe_integration: "Y",
      platform_fee_applicable: "Y",
      platform_fee_us_bank_account_max_charge: "5",
      connected_account_id: "acct_1SPfmkH8KVcXtDPF",
      platform_fee_card_percent: "2.9",
      platform_fee_us_bank_account_percent: "0.8",
      payment_method: "US_BANK_ACCOUNT,CARD"
    }
  },
  {
    invoiceId: 1433,
    mfgInvoiceNumber: "INV2026022001",
    actualRemainingAmount: 7122064.32,
    stripeConfig: {
      platform_fee_card_additional: "0.3",
      stripe_integration: "Y",
      platform_fee_applicable: "Y",
      platform_fee_us_bank_account_max_charge: "5",
      connected_account_id: "acct_1SPfmkH8KVcXtDPF",
      platform_fee_card_percent: "2.9",
      platform_fee_us_bank_account_percent: "0.8",
      payment_method: "US_BANK_ACCOUNT,CARD"
    },
    manufacturerStripeConfig: {
      platform_fee_card_additional: "0.3",
      stripe_integration: "Y",
      platform_fee_applicable: "Y",
      platform_fee_us_bank_account_max_charge: "5",
      connected_account_id: "acct_1SPfmkH8KVcXtDPF",
      platform_fee_card_percent: "2.9",
      platform_fee_us_bank_account_percent: "0.8",
      payment_method: "US_BANK_ACCOUNT,CARD"
    }
  },
  {
    invoiceId: 1432,
    mfgInvoiceNumber: "INV2026008001",
    actualRemainingAmount: 7065540,
    stripeConfig: {
      platform_fee_card_additional: "0.3",
      stripe_integration: "Y",
      platform_fee_applicable: "Y",
      platform_fee_us_bank_account_max_charge: "5",
      connected_account_id: "acct_1SPfmkH8KVcXtDPF",
      platform_fee_card_percent: "2.9",
      platform_fee_us_bank_account_percent: "0.8",
      payment_method: "US_BANK_ACCOUNT,CARD"
    },
    manufacturerStripeConfig: {
      platform_fee_card_additional: "0.3",
      stripe_integration: "Y",
      platform_fee_applicable: "Y",
      platform_fee_us_bank_account_max_charge: "5",
      connected_account_id: "acct_1SPfmkH8KVcXtDPF",
      platform_fee_card_percent: "2.9",
      platform_fee_us_bank_account_percent: "0.8",
      payment_method: "US_BANK_ACCOUNT,CARD"
    }
  },
  {
    invoiceId: 1400,
    mfgInvoiceNumber: "MFG22006",
    actualRemainingAmount: 1565017.11,
    stripeConfig: {
      platform_fee_card_additional: "0.3",
      stripe_integration: "Y",
      platform_fee_applicable: "Y",
      platform_fee_us_bank_account_max_charge: "5",
      connected_account_id: "acct_1SPfmkH8KVcXtDPF",
      platform_fee_card_percent: "2.9",
      platform_fee_us_bank_account_percent: "0.8",
      payment_method: "US_BANK_ACCOUNT,CARD"
    },
    manufacturerStripeConfig: {
      platform_fee_card_additional: "0.3",
      stripe_integration: "Y",
      platform_fee_applicable: "Y",
      platform_fee_us_bank_account_max_charge: "5",
      connected_account_id: "acct_1SPfmkH8KVcXtDPF",
      platform_fee_card_percent: "2.9",
      platform_fee_us_bank_account_percent: "0.8",
      payment_method: "US_BANK_ACCOUNT,CARD"
    }
  },
  {
    invoiceId: 1360,
    mfgInvoiceNumber: "INV2025345003",
    actualRemainingAmount: 3511573.38,
    stripeConfig: {
      platform_fee_card_additional: "0.3",
      stripe_integration: "Y",
      platform_fee_applicable: "Y",
      platform_fee_us_bank_account_max_charge: "5",
      connected_account_id: "acct_1SPfmkH8KVcXtDPF",
      platform_fee_card_percent: "2.9",
      platform_fee_us_bank_account_percent: "0.8",
      payment_method: "US_BANK_ACCOUNT,CARD"
    },
    manufacturerStripeConfig: {
      platform_fee_card_additional: "0.3",
      stripe_integration: "Y",
      platform_fee_applicable: "Y",
      platform_fee_us_bank_account_max_charge: "5",
      connected_account_id: "acct_1SPfmkH8KVcXtDPF",
      platform_fee_card_percent: "2.9",
      platform_fee_us_bank_account_percent: "0.8",
      payment_method: "US_BANK_ACCOUNT,CARD"
    }
  },
  {
    invoiceId: 1358,
    mfgInvoiceNumber: "INV2025345001",
    actualRemainingAmount: 3281943.33,
    stripeConfig: {
      platform_fee_card_additional: "0.3",
      stripe_integration: "Y",
      platform_fee_applicable: "Y",
      platform_fee_us_bank_account_max_charge: "5",
      connected_account_id: "acct_1SPfmkH8KVcXtDPF",
      platform_fee_card_percent: "2.9",
      platform_fee_us_bank_account_percent: "0.8",
      payment_method: "US_BANK_ACCOUNT,CARD"
    },
    manufacturerStripeConfig: {
      platform_fee_card_additional: "0.3",
      stripe_integration: "Y",
      platform_fee_applicable: "Y",
      platform_fee_us_bank_account_max_charge: "5",
      connected_account_id: "acct_1SPfmkH8KVcXtDPF",
      platform_fee_card_percent: "2.9",
      platform_fee_us_bank_account_percent: "0.8",
      payment_method: "US_BANK_ACCOUNT,CARD"
    }
  },
  {
    invoiceId: 1306,
    mfgInvoiceNumber: "INV2025337005",
    actualRemainingAmount: 133460,
    stripeConfig: {
      platform_fee_card_additional: "0.3",
      stripe_integration: "Y",
      platform_fee_applicable: "Y",
      platform_fee_us_bank_account_max_charge: "5",
      connected_account_id: "acct_1SPfmkH8KVcXtDPF",
      platform_fee_card_percent: "2.9",
      platform_fee_us_bank_account_percent: "0.8",
      payment_method: "US_BANK_ACCOUNT,CARD"
    },
    manufacturerStripeConfig: {
      platform_fee_card_additional: "0.3",
      stripe_integration: "Y",
      platform_fee_applicable: "Y",
      platform_fee_us_bank_account_max_charge: "5",
      connected_account_id: "acct_1SPfmkH8KVcXtDPF",
      platform_fee_card_percent: "2.9",
      platform_fee_us_bank_account_percent: "0.8",
      payment_method: "US_BANK_ACCOUNT,CARD"
    }
  },
  {
    invoiceId: 1305,
    mfgInvoiceNumber: "INV2025337004",
    actualRemainingAmount: 84050,
    stripeConfig: {
      platform_fee_card_additional: "0.3",
      stripe_integration: "Y",
      platform_fee_applicable: "Y",
      platform_fee_us_bank_account_max_charge: "5",
      connected_account_id: "acct_1SPfmkH8KVcXtDPF",
      platform_fee_card_percent: "2.9",
      platform_fee_us_bank_account_percent: "0.8",
      payment_method: "US_BANK_ACCOUNT,CARD"
    },
    manufacturerStripeConfig: {
      platform_fee_card_additional: "0.3",
      stripe_integration: "Y",
      platform_fee_applicable: "Y",
      platform_fee_us_bank_account_max_charge: "5",
      connected_account_id: "acct_1SPfmkH8KVcXtDPF",
      platform_fee_card_percent: "2.9",
      platform_fee_us_bank_account_percent: "0.8",
      payment_method: "US_BANK_ACCOUNT,CARD"
    }
  },
  {
    invoiceId: 1304,
    mfgInvoiceNumber: "INV2025337003",
    actualRemainingAmount: 21972.5,
    stripeConfig: {
      platform_fee_card_additional: "0.3",
      stripe_integration: "Y",
      platform_fee_applicable: "Y",
      platform_fee_us_bank_account_max_charge: "5",
      connected_account_id: "acct_1SPfmkH8KVcXtDPF",
      platform_fee_card_percent: "2.9",
      platform_fee_us_bank_account_percent: "0.8",
      payment_method: "US_BANK_ACCOUNT,CARD"
    },
    manufacturerStripeConfig: {
      platform_fee_card_additional: "0.3",
      stripe_integration: "Y",
      platform_fee_applicable: "Y",
      platform_fee_us_bank_account_max_charge: "5",
      connected_account_id: "acct_1SPfmkH8KVcXtDPF",
      platform_fee_card_percent: "2.9",
      platform_fee_us_bank_account_percent: "0.8",
      payment_method: "US_BANK_ACCOUNT,CARD"
    }
  },
  {
    invoiceId: 1303,
    mfgInvoiceNumber: "INV2025337002",
    actualRemainingAmount: 2740,
    stripeConfig: {
      platform_fee_card_additional: "0.3",
      stripe_integration: "Y",
      platform_fee_applicable: "Y",
      platform_fee_us_bank_account_max_charge: "5",
      connected_account_id: "acct_1SPfmkH8KVcXtDPF",
      platform_fee_card_percent: "2.9",
      platform_fee_us_bank_account_percent: "0.8",
      payment_method: "US_BANK_ACCOUNT,CARD"
    },
    manufacturerStripeConfig: {
      platform_fee_card_additional: "0.3",
      stripe_integration: "Y",
      platform_fee_applicable: "Y",
      platform_fee_us_bank_account_max_charge: "5",
      connected_account_id: "acct_1SPfmkH8KVcXtDPF",
      platform_fee_card_percent: "2.9",
      platform_fee_us_bank_account_percent: "0.8",
      payment_method: "US_BANK_ACCOUNT,CARD"
    }
  }
];



  // Handle bulk payment
  const handleBulkPayment = () => {
    // const practiceIds = getValues("practiceIds");
    // const mfgIds = getValues("mfgIds");

    // // Validation: Both Practice and Manufacturer must be selected
    // if (!practiceIds || practiceIds.length === 0 || !mfgIds || mfgIds.length === 0) {
    //   const alertObj: SingleAlertInfo = {
    //     message: "Please select both Manufacturer and Practice to search invoices.",
    //     alertType: "error",
    //   };
    //   dispatch(setSingleAlertObj(alertObj));
    //   return;
    // }

    // // Validation: Only one Practice and one Manufacturer should be selected
    // if (practiceIds.length > 1 || mfgIds.length > 1) {
    //   const alertObj: SingleAlertInfo = {
    //     message: "Please select only one Practice and one Manufacturer for bulk payment.",
    //     alertType: "error",
    //   };
    //   dispatch(setSingleAlertObj(alertObj));
    //   return;
    // }

    // Open bulk payment popup with selected invoices
    setShowBulkPaymentPopup(true);
  };

  const handleSelectAllCheckBox = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target;
    
    if (checked) {
      // When checking "Select All", we need to determine which manufacturer+practice to use
      let targetMfgId = selectedMfgAndPractice.manufacturerId;
      let targetPracticeId = selectedMfgAndPractice.practiceId;
      
      // If no selection exists yet, use the first eligible invoice
      if (targetMfgId === null || targetPracticeId === null) {
        const firstEligibleRow = formattedInvoiceRows?.find(row => {
          const isStripeEnabled = row?.stripeConfig?.stripe_integration === 'Y';
          const isPartialOrUnpaid = row?.invoiceStatus === "PARTIAL" || row?.invoiceStatus === "UNPAID";
          const hasOutstandingAmount = Number(row?.actualRemainingAmount ?? 0) > 0;
          return isStripeEnabled && isPartialOrUnpaid && hasOutstandingAmount;
        });
        
        if (firstEligibleRow) {
          targetMfgId = firstEligibleRow.manufacturerId;
          targetPracticeId = firstEligibleRow.practiceId;
          setSelectedMfgAndPractice({ 
            manufacturerId: targetMfgId, 
            practiceId: targetPracticeId 
          });
        }
      }
      
      // Now check ONLY invoices that have checkboxes rendered (match all conditions)
      formattedInvoiceRows?.forEach(row => {
        // Check if this invoice should have a checkbox rendered
        const isStripeEnabled = row?.stripeConfig?.stripe_integration === 'Y';
        const isPartialOrUnpaid = row?.invoiceStatus === "PARTIAL" || row?.invoiceStatus === "UNPAID";
        const hasOutstandingAmount = Number(row?.actualRemainingAmount ?? 0) > 0;
        const hasCheckbox = isStripeEnabled && isPartialOrUnpaid && hasOutstandingAmount;
        
        // Only check if it has a checkbox AND matches manufacturer+practice
        if (hasCheckbox && targetMfgId === row.manufacturerId && targetPracticeId === row.practiceId) {
          //@ts-ignore
          setValue(`checkBox.invoice_${row.invoiceId}`, true);
        }
      });
    } else {
      // When unchecking "Select All", uncheck all checkboxes and clear selection
      formattedInvoiceRows?.forEach(row => {
        //@ts-ignore
        setValue(`checkBox.invoice_${row.invoiceId}`, false);
      });
      setSelectedMfgAndPractice({ manufacturerId: null, practiceId: null });
    }
  }, [formattedInvoiceRows, selectedMfgAndPractice, setValue, setSelectedMfgAndPractice]);

  const practiceIdsList = useMemo(() => {
    return (
      practiceByUserRole?.map((practice) => parseInt(practice.practiceId)) || []
    );
  }, [practiceByUserRole]);

    const patientListoption = useMemo(() => {
    return (
      patientsByUserRole?.map((patient) => patient.patientId) || []
    );
  }, [patientsByUserRole]);

  // const mfgIdsList = useMemo(() => {
  //   return manufacturerInfoList?.map((mfg) => mfg.manufacturerId) || [];
  // }, [manufacturerInfoList]);

  const agencyIdsList = useMemo(() => {
    return agencyInfoList?.map((agy) => parseInt(agy.agencyId)) || [];
  }, [agencyInfoList]);

  const ovrAgencyIdsList = useMemo(() => {
    return agencyInfoList
    ?.filter(option => option.commissionType === 'Override')
    ?.map((agy) => parseInt(agy.agencyId)) || [];
  }, [agencyInfoList]);

  const searchInvoiceList = useCallback(
    (currentPage: number, obj?: SearchInvoiceInfo) => {
      let data: SearchInvoiceInfo = {
        fromDate: obj?.fromDate,
        toDate: obj?.toDate,
        commPeriod: obj?.commPeriod,
        mfgIds: obj?.mfgIds
          ? obj.mfgIds
          // : mfgIdsList?.length === 1
          //   ? mfgIdsList
            : [],
        agencyIds: obj?.agencyIds
          ? obj.agencyIds
          // : agencyIdsList?.length === 1
          //   ? agencyIdsList
            : [],
        patientIds: obj?.patientIds
          ? obj.patientIds
          // : patientListoption?.length === 1
          //   ? patientListoption
            : [],
        practiceIds: obj?.practiceIds
          ? obj.practiceIds
          // : practiceIdsList?.length === 1
          //   ? practiceIdsList
            : [],
        mfgInvoiceNumber: obj?.mfgInvoiceNumber ? obj.mfgInvoiceNumber : "",
        serialNumber: obj?.serialNumber ? obj.serialNumber : "",
        orderNumber: obj?.orderNumber ? obj.orderNumber : "",
        invoiceStatus: obj?.invoiceStatus ? obj.invoiceStatus : [],
        currentPage: currentPage,
        itemsPerPage: ITEMS_PER_PAGE,
        usageStatus: obj?.usageStatus ? obj.usageStatus : "",
        productIds: obj?.productIds ? obj.productIds : [],
        isDownload: false,
        excludePurchaseAndBill: false,
        purchaseAndBillFilter: obj?.purchaseAndBillFilter ? obj.purchaseAndBillFilter : "",
        invoiceId:obj?.invoiceId ? obj.invoiceId : undefined,
        alertInvoices:obj?.alertInvoices||false,
        invoiceAgeMin: obj?.invoiceAgeMin === "" ? undefined : obj?.invoiceAgeMin,
        invoiceAgeMax: obj?.invoiceAgeMax === "" ? undefined : obj?.invoiceAgeMax,
        invoiceAging: Array.isArray(obj?.invoiceAging)
          ? obj?.invoiceAging
          : obj?.invoiceAging
            ? [obj?.invoiceAging]
            : [],
        ...invoiceListSort.pick(obj),
      };
      setValue("currentPage", currentPage);
      setValue("sortBy", data.sortBy);
      setValue("sortOrder", data.sortOrder);
      setSearchCriteria(data);
      if (userInfo.userRole !== USER_ROLES.ROLE_PRACTICE_USER_PRU) {
        dispatch(fetchInvoiceList(data));
      } else {
        dispatch(showHideLoadingDialog(false))
      }
    },
    [practiceByUserRole, manufacturerInfoList , isAlertOnly]
  );

  const setSearchCriteria = useCallback((data: SearchInvoiceInfo) => {
    setSearchCriteriaToSessionStorage(CAN_ACCESS_APPLICATION.INVOICE_MANAGEMENT + "SearchCriteria" + userInfo.userId, data);
  }, []);

  const handleDateRangeChange = (fromDate: DateObject | null, toDate: DateObject | null) => {
    const fromDateString = fromDate ? fromDate.format("MM/DD/YYYY") : null;
    const toDateString = toDate ? toDate.format("MM/DD/YYYY") : null;

    setValue("fromDate", fromDateString ? fromDateString : "");
    setValue("toDate", toDateString ? toDateString : "");


    setIsDateRangeChanged(true);
  };

  const handleDateChange = (date: Date | null, endDate?: Date | null) => {
    if (date && endDate) {
      const formattedStart = format(date, "MMM yy");
      const formattedEnd = format(endDate, "MMM yy");
      
      setValue('commPeriod', `${formattedStart} - ${formattedEnd}`);
    } else if (date && !endDate) {
      const formattedDate = format(date, "MMM yy");
      setValue('commPeriod', formattedDate);
    }
  };

  const handleClearDateChange = () => {
    setValue('commPeriod', "");
  }

  const [uploadPopupInfo, setUploadPopupInfo] = useState({
    title: "",
    fileName: "",
    filePath: "",
  });

  const showPaymentPopup = (popupName: string) => {
    if (popupName === "Import Invoices") {
      setUploadPopupInfo({
        title: popupName,
        fileName: branding?.companyNameShort+"_Template_Import_Invoice_.xlsx",
        filePath: "/Bio_Template_Import_Invoice_.xlsx",
      });
    } else if (popupName === "Import Invoice Payments") {
      setUploadPopupInfo({
        title: popupName,
        fileName:  branding?.companyNameShort+"_Template_Invoice_Payments.xlsx",
        filePath: "/Bio_Template_Invoice_Payments.xlsx",
      });
    } else {
      setUploadPopupInfo({
        title: popupName,
        fileName: branding?.companyNameShort + "_Template_Invoice_Service_Fee_Payments.xlsx",
        filePath: "/branding/Bio_Template_Invoice_Service_Fee_Payments.xlsx",
      });
    }
    setShowUploadsPaymentsPopup(true);
  };

  // Function to export data to Excel
  const handleExport = () => {

    const searchCriteriaFromStorage = getSearchCriteriaFromSessionStorage(CAN_ACCESS_APPLICATION.INVOICE_MANAGEMENT + "SearchCriteria" + userInfo.userId);

    if (searchCriteriaFromStorage) {

      let initData: SearchInvoiceInfo = {
        fromDate: searchCriteriaFromStorage.fromDate || "",
        toDate: searchCriteriaFromStorage.toDate || "",
        mfgIds: searchCriteriaFromStorage.mfgIds || [],
        agencyIds: searchCriteriaFromStorage.agencyIds || [],
        practiceIds: searchCriteriaFromStorage.practiceIds || [],
        mfgInvoiceNumber: searchCriteriaFromStorage.mfgInvoiceNumber || "",
        orderNumber: searchCriteriaFromStorage.orderNumber || "",
        invoiceStatus: searchCriteriaFromStorage.invoiceStatus || [],
        invoiceAgeMin: searchCriteriaFromStorage.invoiceAgeMin,
        invoiceAgeMax: searchCriteriaFromStorage.invoiceAgeMax,
        invoiceAging: Array.isArray(searchCriteriaFromStorage.invoiceAging)
          ? searchCriteriaFromStorage.invoiceAging
          : searchCriteriaFromStorage.invoiceAging
            ? [searchCriteriaFromStorage.invoiceAging]
            : [],
        currentPage: getValues("currentPage"),
        itemsPerPage: ITEMS_PER_PAGE,
        patientIds: searchCriteriaFromStorage.patientIds || [],
        serialNumber: searchCriteriaFromStorage.serialNumber || "",
        usageStatus: searchCriteriaFromStorage.usageStatus || "",
        productIds: searchCriteriaFromStorage.productIds || [],
        commPeriod: searchCriteriaFromStorage.commPeriod || "",
        isDownload: true,
        excludePurchaseAndBill: false,
        purchaseAndBillFilter: searchCriteriaFromStorage.purchaseAndBillFilter || "",
        ...invoiceListSort.pick(searchCriteriaFromStorage),
      };

      const updatedColumns = columnsInvoice.map(col => {
        if (col.id === "customInvoiceStatus") {
          return { ...col, id: "invoiceStatus" }; // replace id
        }
        if (col.id === "mfgInvoiceNumberLink") {
          return { ...col, id: "mfgInvoiceNumber" };
        }
        return col;
      });
      ExportToExcel(initData, updatedColumns, dispatch, EXPORTABLE_ITEMS.INVOICE, hiddenColumns);

    }
  }
  // const selectedInvList = () => {
  //   const checkedList: any = getValues('checkBox');
  //   const checkedIdList: number[] = Object.entries(
  //     checkedList
  //   )
  //     .filter(([invoiceIdString, isChecked]) => isChecked)
  //     .map(([invoiceIdString]) => parseInt(invoiceIdString.split("_")[1]));

  //   const selectedRows: invoiceInfo[] = []
  //   checkedIdList.forEach((invId: number) => {
  //     const invoice = invoiceList?.content?.find(inv => inv.invoiceId === invId);
  //     if (invoice) {
  //       selectedRows.push(invoice)
  //     }
  //   });
  //   return selectedRows;
  // }

  // const navigateRecordPayout = () => {
  //   const selectedRows: invoiceInfo[] = selectedInvList();
  //   if (selectedRows?.length > 0) {
  //     navigate("/recordPayout", { state: { selectedInvoices: selectedRows } });
  //   } else {
  //     let errObj: SingleAlertInfo = {
  //       message: "Please select at least one invoice.",
  //       alertType: "error"
  //     };
  //     dispatch(setSingleAlertObj(errObj));
  //   }
  // };

  // const navigateAgyRecordPayout = () => {
  //   const selectedRows: invoiceInfo[] = selectedInvList();
  //   const isOvrAgenciesFound = selectedRows.every(row => row.overrideAgencyId);
  //   if (!selectedRows || selectedRows?.length == 0) {
  //     let errObj: SingleAlertInfo = {
  //       message: "Please select at least one invoice.",
  //       alertType: "error"
  //     };
  //     dispatch(setSingleAlertObj(errObj));
  //   } else if (!isOvrAgenciesFound) {
  //     let errObj: SingleAlertInfo = {
  //       message: "Please select invoice/s with override agencies.",
  //       alertType: "error"
  //     };
  //     dispatch(setSingleAlertObj(errObj));
  //   } else {
  //     navigate("/overrideRecordPayout", { state: { selectedInvoices: selectedRows } });
  //   };
  // };

  const handleOrderListNavigate = (row: any) => {
    if (row?.orderNumber !== null) {
      navigate("/order_list", { state: { orderNumber: row.orderNumber } });
    };
  };

  const handleMenuClose = () => {
    setAnchorElMenu(null);
  };
  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElMenu(event.currentTarget);
  };

  useEffect(() => () => {
    dispatch(resetInvoiceList())
  }, []);

  useEffect(()=>{
    if(fetchInitDataCompleted){
      if(userInfo.notificationEnable && canAccessNotifications){
        if(fetchNotificationCountCompleted && fetchNotificationsCompleted){
          setLoadingComplete(true)
        }
      } else {
        setLoadingComplete(true)
      }
    }
  },[fetchInitDataCompleted, fetchNotificationCountCompleted, fetchNotificationsCompleted])

  useEffect(()=>{
    if(loadingComplete && invoiceList){
      dispatch(showHideLoadingDialog(false))
    }
  },[loadingComplete, invoiceList])

  const handleConfirm = (data: any) => {
    if (selectedInvoiceId) {
      dispatch(addLateFeeByInvoice({
        invoiceId: selectedInvoiceId,
        lateFee: data.lateFee,
        skipLoader: true
      })).then(()=>{
        searchInvoiceList(1, { ...getValues() });
      })
      setIsPopupOpen(false);
      setSelectedInvoiceId(null);
      setLateFeeAmount(0);
    }
  };

  const totalRecords = invoiceList?.totalElements ?? 0;
  return (
    <>
      {userInfo.notificationEnable &&
        <StatusInfoPopup
          anchorEl={statusAnchorEl}
          onAcknowledge={handleAcknowledge}
          onClose={() => {
            setStatusAnchorEl(null)
          }
          }
          rows={notificationData}
        />
      }
      {/* CS-1458 - Stripe Payment Type Popup */}
      {showStripePaymentTypePopup && (
        <StripePaymentTypePopup
          open={showStripePaymentTypePopup}
          onClose={() => setShowStripePaymentTypePopup(false)}
          invoiceData={selectedInvoiceData}
          createCheckoutSession={handleCheckout}
        />
      )}
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          px: { xs: 1, md: 3 },
          py: 2,
        }}
      >
        {/* <Header title="Invoice List" /> */}
        {showUploadPaymentsPopup && (
          <UploadPaymentsPopup
            open={showUploadPaymentsPopup}
            title={uploadPopupInfo.title}
            downloadFileName={uploadPopupInfo.fileName}
            downloadFilePath={uploadPopupInfo.filePath}
            onClose={() => {
              setShowUploadsPaymentsPopup(false);
              pagination(0);
            }}
          />
        )}
        {/* CS-1532 - Start */}
        {showOptionPopup.show && (
          <OptionsPopup
            open={showOptionPopup.show}
            onClose={() => setShowOptionsPopup({ message: "", show: false })}
            variant={showOptionPopup.variant}
            message={<>{showOptionPopup.message}</>}
            buttons={showOptionPopup.buttons}
            title={showOptionPopup.title}
            obj={showOptionPopup.obj}
          />
        )}
        {/* CS-1532 - End */}

      <Dialog
        open={overridePayoutInvoices !== null}
        onClose={handleCloseOverridePayout}
        fullWidth
        maxWidth="lg"
        fullScreen={isMobile}
        sx={{ zIndex: 1600 }}
        PaperProps={{ sx: paperSx(isMobile) }}
      >
        {overridePayoutInvoices !== null ? (
          <>
            <Box sx={headerSx}>
              <Box sx={iconBoxSx(modalTokens.accent)}>
                <PaymentsOutlined sx={{ fontSize: "1.25rem", color: modalTokens.accent }} />
              </Box>
              <Box sx={{ flex: 1, pr: 4 }}>
                <Typography fontWeight={700} sx={{ fontSize: "1.1rem", color: modalTokens.textPrimary, lineHeight: 1.3 }}>
                  Record Payout
                </Typography>
                <Typography sx={{ fontSize: "0.8rem", color: modalTokens.textSecondary, mt: 0.15 }}>
                  Pay the override service fees for the selected invoices.
                </Typography>
              </Box>
              <IconButton onClick={handleCloseOverridePayout} size="small" sx={closeIconSx} aria-label="Close">
                <CloseOutlined sx={{ fontSize: "1rem" }} />
              </IconButton>
            </Box>
            <Box sx={bodySx}>
              <RecordPayoutOverrideForm
                selectedInvoices={overridePayoutInvoices}
                onCancel={handleCloseOverridePayout}
                onRecorded={handleOverridePayoutRecorded}
                overlayZIndex={1600}
              />
              </Box>
            </>
          ) : null}
        </Dialog>
      <Dialog
        open={agencyPayoutInvoices !== null}
        onClose={handleCloseAgencyPayout}
        fullWidth
        maxWidth="lg"
        fullScreen={isMobile}
        sx={{ zIndex: 1600 }}
        PaperProps={{ sx: paperSx(isMobile) }}
      >
        {agencyPayoutInvoices !== null ? (
          <>
            <Box sx={headerSx}>
              <Box sx={iconBoxSx(modalTokens.accent)}>
                <PaymentsOutlined sx={{ fontSize: "1.25rem", color: modalTokens.accent }} />
              </Box>
              <Box sx={{ flex: 1, pr: 4 }}>
                <Typography fontWeight={700} sx={{ fontSize: "1.1rem", color: modalTokens.textPrimary, lineHeight: 1.3 }}>
                  Record Payout
                </Typography>
                <Typography sx={{ fontSize: "0.8rem", color: modalTokens.textSecondary, mt: 0.15 }}>
                  Pay the agency service fees for the selected invoices.
                </Typography>
              </Box>
              <IconButton onClick={handleCloseAgencyPayout} size="small" sx={closeIconSx} aria-label="Close">
                <CloseOutlined sx={{ fontSize: "1rem" }} />
              </IconButton>
            </Box>
            <Box sx={bodySx}>
              <RecordPayoutForm
                selectedInvoices={agencyPayoutInvoices}
                onCancel={handleCloseAgencyPayout}
                onRecorded={handleAgencyPayoutRecorded}
                overlayZIndex={1600}
              />
            </Box>
          </>
        ) : null}
      </Dialog>
      <EditCommissionPopup
        open={serviceFeeEdit !== null}
        handleClose={() => setServiceFeeEdit(null)}
        mode="commission-details"
        uiVariant="billing"
        showReasonField
        disableAmountField={false}
        disableRateField
        paymentData={serviceFeeEdit?.paymentData ?? null}
        agencyData={serviceFeeEdit?.agencyData ?? null}
        onCommissionRateUpdate={handleServiceFeeUpdate}
        zIndex={1600}
      />
         <LateFeePopup
          open={isPopupOpen}
          onClose={() => {
            setIsPopupOpen(false);
            setSelectedInvoiceId(null);
            setLateFeeAmount(0);
          }}
          onConfirm={handleConfirm}
          lateFeeReceivedAmount={lateFeeAmount}
          currency="$"
          lateFeeAmountLabel="Outstanding Late Fee"
        />
        
        {/* Bulk Invoice Payment Popup */}
        {showBulkPaymentPopup && (
          <BulkInvoicePayment
            open={showBulkPaymentPopup}
            onClose={() => setShowBulkPaymentPopup(false)}
            practiceOptions={practiceList}
            // CS-1995 - product options are now fetched inside the dialog per selected practice
            createCheckoutSession={handleCheckout}
            onResetSelection={() => {
              // Reset all checkboxes in InvoiceList
              setValue('selectAllCheckBox', false);
              
              // Clear all individual invoice checkboxes
              formattedInvoiceRows?.forEach(row => {
                setValue(`checkBox.invoice_${row.invoiceId}`, false);
              });
              
              // Reset manufacturer+practice selection
              setSelectedMfgAndPractice({ manufacturerId: null, practiceId: null });
              
              // Fetch latest invoice data
              searchInvoiceList(1, { ...getValues() });
            }}
          />
        )}
        
        <Box ref={filterPanelRef} sx={{ position: "relative", zIndex: 20, overflow: "visible" }}>
          <Collapse
            in={showCard}
            onEntering={handleFilterPanelEntering}
            onEntered={handleFilterPanelEntered}
            onExited={handleFilterPanelExited}
          >
            <Card sx={filterPanelSx}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2} alignItems="flex-end">
                    {/* Row 1: Invoice ID | Order ID | Serial Number | Agency */}
                    <Grid item md={3} xs={12}>
                      <CustomTextField
                        controllerName="mfgInvoiceNumber"
                        control={control}
                        name="mfgInvoiceNumber"
                        label="Invoice ID"
                        placeholder="Enter invoice ID"
                        size="small"
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                      <CustomTextField
                        controllerName="orderNumber"
                        control={control}
                        name="orderNumber"
                        //CS-1141 - Start
                        label="Order ID"
                        placeholder="Enter order ID"
                        size="small"
                        //CS-1141- End
                      />
                    </Grid>
                    <Grid item md={3} xs={12}>
                      <CustomTextField
                        controllerName="serialNumber"
                        control={control}
                        name="serialNumber"
                        label="Serial Number"
                        placeholder="Enter serial number"
                        size="small"
                      />
                    </Grid>
                    <Grid item md={3} xs={12}>
                      <CustomMultipleDropDown
                        control={control}
                        name="agencyIds"
                        label="Agency"
                        placeholderText="Select agency"
                        options={agenciesList}
                         disabled={(userInfo.entityName === USER_ROLE_ENTITY_NAMES.AGENCY || userInfo.entityName === USER_ROLE_ENTITY_NAMES.ACCOUNTEXECUTIVE) ? agenciesList?.length === 1 : false}
                        size="small"
                      />
                    </Grid>
                    {/* Row 2: Pay Period | Invoice Date Range | Practice | Patient */}
                    <Grid item md={3} xs={12}>
                      <CustomMonthYearPicker
                        label="Pay Period"
                        control={control}
                        controllerName="comm"
                        name="comm"
                        onDateChange={handleDateChange}
                        // isRange={true}
                        onClear={handleClearDateChange}
                      />
                    </Grid>
                    <Grid item md={3} xs={12}>
                      <CustomDateRange
                        label="Invoice Date Range"
                        control={control}
                        controllerName="dateRange"
                        onChange={handleDateRangeChange}
                        // dateRangeMonths={6}
                        onClear={isClearDateRange}
                      />
                    </Grid>
                    <Grid item md={3} xs={12}>
                      <CustomMultipleDropDown
                        control={control}
                        name="practiceIds"
                        label="Practice"
                        placeholderText="Select practice"
                        options={practiceList}
                        disabled={practiceList?.length === 1}
                        size="small"
                      />
                    </Grid>
                    <Grid item md={3} xs={12}>
                      <CustomMultipleDropDown
                        control={control}
                        name="patientIds"
                        label="Patient"
                        placeholderText="Select patient"
                        options={patientsOptions}
                        disabled={(userInfo.entityName === USER_ROLE_ENTITY_NAMES.BILLER || userInfo.entityName === USER_ROLE_ENTITY_NAMES.ACCOUNTEXECUTIVE || userInfo.entityName === USER_ROLE_ENTITY_NAMES.MANUFACTURER)? patientsOptions?.length === 0 : false}
                        size="small"
                      />
                    </Grid>
                    {/* Row 3: Manufacturer | Product | Purchase & Bill | Usage Status */}
                    <Grid item md={3} xs={12}>
                      <CustomMultipleDropDown
                        control={control}
                        name="mfgIds"
                        label="Manufacturer"
                        placeholderText="Select manufacturer"
                        options={manufacturesList}
                        disabled={(userInfo.entityName === USER_ROLE_ENTITY_NAMES.MANUFACTURER) ? manufacturesList?.length === 1 : false}
                        size="small"
                      />
                    </Grid>
                    <Grid item md={3} xs={12}>
                      <CustomMultipleDropDown
                        control={control}
                        name="productIds"
                        label="Product"
                        placeholderText="Select product"
                        options={productOptions}
                        size="small"
                      />
                    </Grid>
                    {/* CS-2028 - Purchase & Bill filter: only visible to SuperAdmin and Admin */}
                    {canAccessPurchaseAndBillFilter && (
                      <Grid item md={3} xs={12}>
                        <CustomDropdownField
                          control={control}
                          name="purchaseAndBillFilter"
                          label="Purchase & Bill"
                          placeholderText="Select purchase & bill"
                          options={purchaseAndBillOptions}
                          sortOptions={false}
                          size="small"
                        />
                      </Grid>
                    )}
                    <Grid item md={3} xs={12}>
                      <CustomDropdownField
                        control={control}
                        name="usageStatus"
                        label="Usage Status"
                        placeholderText="Select usage status"
                        options={usageStatusOptions}
                        size="small"
                      />
                    </Grid>
                    {/* Row 4: Invoice Status | Aging (Custom -> Min/Max Age) | Search */}
                    <Grid item md={3} xs={12}>
                      <CustomMultipleDropDown
                        control={control}
                        name="invoiceStatus"
                        label="Invoice Status"
                        placeholderText="Select status"
                        options={invoicesStatusOptions}
                        size="small"
                      />
                    </Grid>
                    {/* CS-2028 - Aging preset dropdown; "Custom" reveals the Min/Max age fields */}
                    <Grid item md={3} xs={12}>
                      <CustomMultipleDropDown
                        control={control}
                        name="invoiceAging"
                        label="Invoice Aging"
                        placeholderText="Select invoice aging"
                        options={invoiceAgingOptions}
                        onChangeSelect={handleAgingChange}
                        sortOptions={false}
                        size="small"
                      />
                    </Grid>
                    {Array.isArray(selectedAging) && selectedAging.includes("CUSTOM") && (
                      <Grid item md={3} xs={12}>
                        <CustomInvoiceAging
                          control={control}
                          minControllerName="invoiceAgeMin"
                          maxControllerName="invoiceAgeMax"
                          minLabel="Min Invoice Age"
                          maxLabel="Max Invoice Age"
                          minPlaceholder="Min invoice age"
                          maxPlaceholder="Max invoice age"
                          outlinedModal
                          autoFocusMin
                          minRules={{
                            validate: (v: any) => {
                              const aging = getValues("invoiceAging");
                              return !Array.isArray(aging) ||
                                !aging.includes("CUSTOM") ||
                                String(v ?? "").trim() !== "" ||
                                String(getValues("invoiceAgeMax") ?? "").trim() !== "" ||
                                "Enter min or max age.";
                            },
                          }}
                          maxRules={{
                            validate: (v: any) => {
                              const aging = getValues("invoiceAging");
                              return !Array.isArray(aging) ||
                                !aging.includes("CUSTOM") ||
                                String(v ?? "").trim() !== "" ||
                                String(getValues("invoiceAgeMin") ?? "").trim() !== "" ||
                                "Enter min or max age.";
                            },
                          }}
                        />
                      </Grid>
                    )}
                    <Grid item md={3} xs={12}>
                    <Button
                      fullWidth
                      size="large"
                      color="success"
                      startIcon={<SearchOutlined />}
                      sx={{ ...primaryActionBtnSx, height: "42px", py: 0 }}
                      type="submit"
                      removeUpperCase
                    >
                      Search
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Card>
          </Collapse>
        </Box>
        <Box mt={2} sx={{ position: "relative", zIndex: 1 }}>
          <Card sx={{ ...cardSx, p: { xs: "14px !important", md: "18px !important" }, position: "relative", zIndex: 1 }}>
            <Grid
              container
              justifyContent="flex-end"
              alignItems="center"
              spacing={1.2}
            >
              <Grid item xs={12} md>
                <Typography variant='h3' fontWeight={800} color="text.primary">Invoice List</Typography>
              </Grid>
              <Grid item xs={12} md="auto">
                {canAccessNotifications && userInfo.notificationEnable
                  && totalNotificationIds && totalNotificationIds.length > 0 &&
                  <CustomIconButton
                    color="warning"
                    variant="contained"
                    tooltipMessage="Invoice Notifications"
                    size="small"
                    notifyCount={totalNotificationIds?.length}
                    onClick={handleNotification}
                  >
                    {isAlertOnly ?
                      <Notifications />
                      :
                      <NotificationsOutlined />
                    }
                  </CustomIconButton>
                }
              </Grid>
              <Grid item xs={12} md="auto">
                <Button
                  variant="outlined"
                  color="info"
                  onClick={toggleFilterPanel}
                  startIcon={<SearchOutlined />}
                  fullWidth
                  sx={invoiceFilterBtnSx}
                  removeUpperCase
                >
                  {showCard ? "Hide Filters" : "Show Filters"}
                </Button>
              </Grid>
              {canCreateStripePayment && (
                <Grid item xs={12} md="auto">
                  <Button
                    variant="contained"
                    color="warning"
                    startIcon={<AttachMoney />}
                    onClick={handleBulkPayment}
                    fullWidth
                    sx={invoiceBulkPaymentBtnSx}
                    removeUpperCase
                  >
                    Bulk Payments 
                    {/* ({selectedInvoiceCount}) */}
                  </Button>
                </Grid>
              )}
              {/* CS-1666 - Share Invoice Button */}
              {canShareInvoice && (
                <Grid item xs={12} md="auto">
                  <Button
                    variant="contained"
                    color="error"
                    startIcon={<Share />}
                    onClick={() => setShowShareInvoicePopup(true)}
                    fullWidth
                    sx={invoiceShareBtnSx}
                    removeUpperCase
                  >
                    Share Invoice
                  </Button>
                </Grid>
              )}
              
              {/* {canAccessImportInvoices ?
                <Grid item xs={12} md="auto">
                  <Button
                    color="info"
                    startIcon={<AssignmentReturnedOutlined />}
                    onClick={() => showPaymentPopup("Import Invoices")}
                    fullWidth
                  >
                    Import Invoices
                  </Button>
                </Grid>
                : ""}
              {canAccessUploadPayments ?
                <Grid item xs={12} md="auto">
                  <Button
                    color="warning"
                    // startIcon={<CloudUpload />}
                    startIcon={<AssignmentReturnedOutlined />}
                    onClick={() => showPaymentPopup("Import Invoice Payments")}
                    fullWidth
                  >
                    Import INV Pmts
                  </Button>
                </Grid>
                : ""}
              {canAccessUploadCommisions ?
                <Grid item xs={12} md="auto">
                  <Button
                    color="info"
                    // startIcon={<CloudUpload />}
                    startIcon={<AssignmentReturnedOutlined />}
                    onClick={() => showPaymentPopup("Import Manufacturer Payments")}
                    fullWidth
                  >
                    Import MFR Pmts
                  </Button>
                </Grid>
                : ""}
              {canAccessCreateAGYPayout ?
                <Grid item xs={12} md="auto">
                  <Button
                    color="error"
                    startIcon={<EditNote />}
                    onClick={() => navigateRecordPayout()}
                    fullWidth
                  >
                    CREATE AGY PMTS
                  </Button>
                </Grid>
                : ""}
              {canAccessCreateOVRAGYPayout ?
                <Grid item xs={12} md="auto">
                  <Button
                    color="secondary"
                    startIcon={<EditNote />}
                    onClick={() => navigateAgyRecordPayout()}
                    fullWidth
                  >
                    CREATE OVR PMTS
                  </Button>
                </Grid>
                : ""} */}
              <Grid item xs={12} md="auto">
                <CustomIconButton
                  onClick={handleColumnToggleClick}
                  color="warning"
                  variant="contained"
                  tooltipMessage="Toggle Columns"
                  size="small"
                  sx={invoiceColumnToggleBtnSx}
                >
                  <TableViewOutlined />
                </CustomIconButton>
                <Popover
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleColumnToggleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                  slotProps={{
                    paper: {
                      sx: {
                        mt: 1,
                        borderRadius: "16px",
                        border: `1px solid ${theme.palette.mode === "dark" ? "rgba(148,163,184,0.2)" : "rgba(15,23,42,0.12)"}`,
                        backgroundColor: theme.palette.mode === "dark" ? "#141720" : "rgba(255,255,255,0.96)",
                        backgroundImage: "none",
                        boxShadow: theme.palette.mode === "dark" ? "0 20px 40px rgba(0,0,0,0.32)" : "0 20px 40px rgba(15,23,42,0.12)",
                      },
                    },
                  }}
                >
                  <ColumnToggle
                    columns={columnsInvoice}
                    hiddenColumns={hiddenColumns}
                    setHiddenColumns={setHiddenColumns}
                  />
                </Popover>
                {/* {isMobile ?
                  (<CustomIconButton
                    color="success"
                    size="small"
                    variant="outlined"
                    tooltipMessage="Download List"
                    tooltipPlacement="top"
                    onClick={(event) => handleMenuClick(event)}
                  >
                    <DownloadOutlined fontSize="small" />
                  </CustomIconButton>)
                  :
                  (<IconButton onClick={(event) => handleMenuClick(event)}>
                    <MoreVertIcon />
                  </IconButton>)
                }
                <Box>
                  <Menu
                    anchorEl={anchorElMenu}
                    open={Boolean(anchorElMenu)}
                    onClose={handleMenuClose}
                  >
                    <MenuItem onClick={() => handleExport()}>
                      <ListItemIcon>
                        <CloudDownload />
                      </ListItemIcon>
                      <Typography variant="inherit" noWrap>
                        Download Search List
                      </Typography>
                    </MenuItem>
                  </Menu>
                </Box> */}
              </Grid>
              {canExportInvoiceList && (
                <Grid item xs={12} md="auto">
                  {!isMobile && (
                    <Button
                      id="customized-button"
                      aria-controls={Boolean(anchorElMenu) ? "customized-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={Boolean(anchorElMenu) ? "true" : undefined}
                      variant="outlined"
                      disableElevation
                      onClick={handleMenuClick}
                      startIcon={<ExitToApp />}
                      sx={invoiceExportBtnSx}
                      removeUpperCase
                      endIcon={
                        <Box
                          component="span"
                          sx={{
                            display: "flex",
                            transition: "transform 0.3s ease",
                            transform: anchorElMenu ? "rotate(180deg)" : "rotate(0deg)",
                            padding: "2px",
                          }}
                        >
                          <KeyboardArrowDown />
                        </Box>
                      }
                    >
                      Export
                    </Button>
                  )}
                </Grid>
              )}

              <Grid item xs={12} md="auto">
                <Box>
                  {canExportInvoiceList && isMobile && (
                    <Box position="absolute" mt={1}>
                      <Button
                        color="success"
                        variant="text"
                        onClick={(event) => handleMenuClick(event)}
                        startIcon={<DownloadOutlined fontSize="small" />}
                        sx={invoiceExportBtnSx}
                        removeUpperCase
                      >
                        Export
                      </Button>
                    </Box>
                  )}

                  <StyledMenu
                    id="customized-menu"
                    MenuListProps={{ "aria-labelledby": "customized-button" }}
                    anchorEl={anchorElMenu}
                    open={Boolean(anchorElMenu)}
                    onClose={handleMenuClose}
                    slotProps={{
                      paper: {
                        sx: exportMenuPaperSx,
                      },
                    }}
                  >

                    <Box sx={{ px: 1, mb: 1 }}>
                      <Button
                        fullWidth
                        variant="outlined"
                        startIcon={<CloudDownload />}
                        onClick={() => handleExport()}
                        disabled={totalRecords > 1000}
                        sx={exportMenuItemBtnSx}
                        removeUpperCase
                      >
                        Export Search List
                      </Button>
                    </Box>

                    {/* <Box sx={{ px: 1, mb: 1 }}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="success"
                        startIcon={<CloudDownload />}
                        disabled={totalRecords > 1000}
                        sx={{
                          py: 1,
                          justifyContent: "flex-start",
                          textTransform: "none",
                          fontSize: "1rem",
                        }}
                      >
                        Export Details List
                      </Button>
                    </Box> */}

                    {totalRecords > 1000 && (
                      <Box
                        sx={{
                          mx: 1,
                          p: 1.5,
                          mt: 1,
                          backgroundColor: "warning.light",
                          borderRadius: 1,
                          color: "warning.contrastText",
                        }}
                      >
                        <Typography variant="body2">
                          Export is available only when the list contains 1,000 records or fewer.
                          Maximum export size: 1000 records.
                        </Typography>
                      </Box>
                    )}
                  </StyledMenu>
                </Box>
              </Grid>

              {/* CS-1294 - End */}
            </Grid>
            <Table
              columns={columnsInvoice}
              rows={loadingComplete ? formattedInvoiceRows || [] : []}
              emptyText="No Invoice(s) Found"
              totalPages={loadingComplete ? invoiceList?.totalPages : 0}
              pageNumber={pagination}
              hiddenColumns={hiddenColumns}
              actionComponent={(row: invoiceTableRow) => actionComponent(row)}
              totalElementText={"Records: " + ((loadingComplete && invoiceList?.totalElements) ? invoiceList?.totalElements : "0")}
              currentPageNumber={getValues("currentPage") ? getValues("currentPage") - 1 : 1}
              showMenu={true}
              sortableColumns={invoiceListSort.sortableColumns}
              serverSideSorting
              onSortChange={handleTableSort}
              controlledSortColumn={invoiceListSort.controlledColumn(getValues("sortBy"))}
              controlledSortOrder={getValues("sortOrder") ?? null}
              uniqueValue="invoiceId"
              currentPageKey="invoiceList"
              activeButtonId={activeButtonId}
              // CS-1555 - Start
              onRowClick={handleRowNavigateToDetails}
              clickableCards={true}
              sx={tableSx}
              // CS-1555 - End
            />
          </Card>
          {showPDF && (
            <PDFViewer
              isOpen={showPDF.isShow}
              onClose={() =>
                setShowPDF({ isShow: false, noteName: "", fileName: "" })
              }
              title={showPDF.noteName}
              fileName={showPDF.fileName}
              base64String={pdfContent || ""}
            />
          )}
          {/* CS-1666 - Share Invoice Popup */}
          {showShareInvoicePopup && (
            <ShareInvoicePopup
              open={showShareInvoicePopup}
              onClose={() => setShowShareInvoicePopup(false)}
              practiceOptions={practiceList}
              manufacturerOptions={manufacturesList}
            />
          )}
        </Box>
      </Box>
    </>
  );
};

export default InvoiceList;